import {Swiper} from 'swiper';
import Popup from "./base/Popup";
import {
    getBottomLayerCountListTmpl,
    getBottomLayerListTmpl,
    getBottomLayerSpinnerTmpl,
    getBottomLayerSpinnerTmplTab,
    getBottomLayerSwiperTmpl,
} from "./templates/popup.template";
import {getFormatZero} from "../utils/util";

import {
    isA11yCheckVersion, 
    isA11ySetAttr, 
    isA11ySlideFocusMove, 
    isPopupMakeCloseButtonOne, 
    isA11yOnceSpinnerDiv,
    isA11yGroupSpinnerUpdate,
    isA11ySwiperBtnChangeAria,
    isDateSpinnerNextTextForceReading,
} from "../functions/a11y.ui";
/**
 * DateSpinner
 */

/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_picker.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_picker.html)
*/

class DateSpinner extends Popup {
    defaults = {
        type: 'dateSpinner',
        slideView : 4
    };

    options = {
        direction: 'vertical',
        slidesPerView: this.defaults.slideView,
        centeredSlides: true,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        a11y: false,
        area:''
    };

    $groupSpinner;

    isHiddenInput = false;
    arrData = [];

    initFn;
    slideChangeFn;
    exportFn;

    swiperIds = [];
    swiperInstances = [];
    selectedValues = [];
    cloneSelectedValues = [];
    savedDataList = {};
    defaultLists = [];
    activeSwiperValue = '';
    // var selectedValues = [2022, 5, 12, '08~09시'];
    dateOption = {};
    dateDataType = [];
    halfTime= ['12시','1시','2시','3시','4시','5시','6시','7시','8시','9시','10시','11시'];
    
    //isA11y 접근성 추가
    isA11ySwipeObj = {
        isUseSwipe: false,
        touchStartX: 0,
        touchEndX: 0,
        swipeDirection: null,
        focusNum: 0,
        focusMaxNum: 0,
        focusArr: null,
    };

    constructor(el, options) {
        super('dateSpinner', el);
        this.init(el, options);
    }

    init(el, options) {
        this.popupInit(el, options);

        this.isHiddenInput = !!this.$el.find('button')[0];

        this.setDone();
        // this.render();

        // [FETASK-702] data-loaded="true"일 경우 init시 selectedvalues 설정
        if(options.loaded){
            this.render();
        }

        //input 값이 있는 상태로 init시 selectedvalues 설정
        if (!this.isHiddenInput && (this.$el.find('input[type=text]').val() !== undefined && this.$el.find('input[type=text]').val() !== '')) {
            this.render();
        }
        this.addClassSet() // 230824 : 추가
        this.detachEvents();
        this.attachEvents();

        /*! s: FETASK-a11y page DateSpinner keyboard엔터 이벤트 공통 바인딩 v.1.0.0 */
        const isA11yCheck = isA11yCheckVersion();

        if(isA11yCheck){
            this.isA11yDateSpinnerKeyEvent();

            /*! s: FETASK-a11y 캘린더 2중팝업 v.1.0.0 */
            const calnEventBtn = document?.querySelector('.jui-datepicker-title');
            calnEventBtn?.setAttribute('tabindex','0');
            /*! e: FETASK-a11y 캘린더 2중팝업 v.1.0.0 */
        }
        /*! e: FETASK-a11y page DateSpinner keyboard엔터 이벤트 공통 바인딩 v.1.0.0 */
    }

    update() {
        this.addClassSet() // 230824 : 추가
        this.detachPopupEvents();
        this.attachPopupEvents();
    }

    render() {
        if (!this.$popup) {
            // SR-1860 스피너 팝업 아닐때
            if (this.defaults.area) {
                this.$popup = $(`[data-spinner-area="${this.defaults.area}"]`);
                this.$popup.append('<div class="group-spinner"></div>');
            } else {
                if (this.defaults.item === 'cycle-date') {
                    if (this.defaults.title == undefined) {
                        this.$popup = $(getBottomLayerSpinnerTmpl(this.defaults.type, '자동이체 주기를 선택해주세요'));
                    } else {
                        this.$popup = $(getBottomLayerSpinnerTmpl(this.defaults.type, this.defaults.title, this.defaults.subTitle));
                    }
                } else if (this.defaults.item === 'cycle-date-tab') { // [CHPFMTASK-2128] TAB + DateSpinner 조합일 경우 2015.04.04
                    if (this.defaults.title == undefined) {
                        this.$popup = $(getBottomLayerSpinnerTmplTab(this.defaults.type, '언제 충전할까요?'));
                    } else {
                        this.$popup = $(getBottomLayerSpinnerTmplTab(this.defaults.type, this.defaults.title, this.defaults.subTitle));
                    }
                } else { 
                    this.$popup = $(getBottomLayerSpinnerTmpl(this.defaults.type, this.defaults.title, this.defaults.subTitle)); //FETASK-988 // FETASK-1181 | 230718 | this.defaults.subTitle 추가
                }
                this.$popup.attr('data-id', this.uiId);
                this.$popupContainer.append(this.$popup);
                this.$groupSpinner = this.$popupContainer.find('.group-spinner');
            }

            // custom
            if(this.$el[0].hasAttribute('data-custom')) {
            }

            // 날짜가 나오는것과 커스텀 데이터로 두가지 형태
            if(
                this.$el.attr('data-date') === 'YYMMDDH1' ||
                this.$el.attr('data-date') === 'YYMMDD' ||
                this.$el.attr('data-date') === 'YYMM' ||
                this.$el.attr('data-date') === 'DD'){

                    
                if (this.$el.attr('data-date') === 'DD') {
                    this.dateDataType = ['DD'];

                    // 시작일
                    const fromDate = this.$el.data('from-date') || new Date('2010-01-01');
                    // 종료일
                    const toDate = this.$el.data('to-date') || new Date('2025-12-31');
                    //toDate.setDate(fromDate.getDate()+5)
                    this.setCallback({
                        initFn: () => {
                            // 최초 값 생성
                            if(this.$el.find('.ui-text-del').val() == '말일'){
                                this.selectedValues.push({text: "말일", value: "32일"});
                            }else{
                                this.selectedValues = this.$el.find('.ui-text-del').val().split('.').map((v) => +v.substr(0,v.length-1));   // '일'제거 후 숫자로 형변환
                            }
                            //console.log('this.selectedValues', this.selectedValues);
                            // 날짜 데이터 생성
                            this.setDateSet(fromDate, toDate);
                        },
                        slideChangeFn: (depth, selectedIndex, data, swiper, selectedValues) => {
                            this.setDateSet(fromDate, toDate);
                        },
                        exportFn: (values) => {
                            // let formatZeroDate = values.map((v) => getFormatZero(v.value)).join('.');
                            let formatStrDate = values.map((v) => this.defaults.cycleLatest ? v.text : v.value+'일').join('.');  // data-cycle-latest="true"인 경우 '말일' 이거나 x일로 출력
                            //console.log('formatStrDate', formatStrDate);
                            this.$el.find('.ui-text-del').val(formatStrDate);
                        }
                    })
                }

                if (this.$el.attr('data-date') === 'YYMM') {
                    this.dateDataType = ['YY', 'MM'];
                    const fromDate = this.el.dataset.fromDate || new Date('2010-01-01');  // 230926 속성값 변경으로 인해 data() => attr() 변경
                    const toDate = this.el.dataset.toDate || new Date('2025-12-31');

                    // console.log(this.el)
                    this.setCallback({
                        initFn: () => {
                            if (this.$el.find('.ui-text-del').attr('today') != undefined){ // FETASK-995
                                this.selectedValues = this.$el.find('.ui-text-del').attr('today').split('-').map((v) => +v); 
                            } else {
                                if(this.$el.find('input[readonly]').val().indexOf('년') > -1){
                                    this.selectedValues = this.$el.find('input[readonly]').val().split(' ').map((v) => parseInt(v));
                                }else{
                                    this.selectedValues = this.$el.find('input[readonly]').val().split('.').map((v) => +v);
                                }
                            }
                            this.setDateSet(fromDate, toDate);
                        },
                        slideChangeFn: (depth, selectedIndex, data, swiper, selectedValues) => {
                            this.setDateSet(fromDate, toDate);
                        },
                        exportFn: (values) => {
                            let formatZeroDate
                            if (this.$el.find('.ui-text-del').attr('today') != undefined) { //FETASK-995
                                formatZeroDate = values.map((v,i) => getFormatZero(v.value)+['년', '월'][i]).join(' ')
                                //formatZeroDate = values.map((v,i) => v.value+['년', '월'][i]).join(' ')
                            } else {
                                if(this.$el.find('input[readonly]').val().indexOf('년') > -1){
                                    formatZeroDate = values.map((v,i) => getFormatZero(v.value)+['년', '월'][i]).join(' ')
                                    //formatZeroDate = values.map((v,i) => v.value+['년', '월'][i]).join(' ')
                                }else{
                                    formatZeroDate = values.map((v) => getFormatZero(v.value)).join('.')
                                    //formatZeroDate = values.map((v) => v.value).join('.')
                                }
                            }
                            this.$el.find('input[readonly]').val(formatZeroDate)
                            if (this.$el.attr('data-spinner-button') == 'true') {
                                this.$el.closest('[data-spinner-group]').find('[spinner-caln-button]').text(formatZeroDate)
                            }
                        }
                    })
                }

                if (this.$el.attr('data-date') === 'YYMMDD') {
                    this.dateDataType = ['YY', 'MM', 'DD'];

                    const fromDate = this.el.dataset.fromDate || new Date('2010-01-01');
                    const toDate = this.el.dataset.toDate || new Date('2025-12-31');

                    this.setCallback({
                        initFn: () => {
                            if (this.$el.find('.ui-text-del').attr('today') != undefined) {  // FETASK-988
                                this.selectedValues = this.$el.find('.ui-text-del').attr('today').split('-').map((v) => +v); 
                            } else {
                                this.selectedValues = this.$el.find('.ui-text-del').val().split('.').map((v) => +v);
                            }
                            this.setDateSet(fromDate,toDate);
                        },
                        slideChangeFn: (depth, selectedIndex, data, swiper, selectedValues) => {
                            this.setDateSet(fromDate,toDate);
                        },
                        exportFn: (values) => {
                            let formatZeroDate

                            if (this.$el.find('.ui-text-del').attr('today') != undefined) {  // FETASK-988
                                if(this.$el.find('input[readonly]').attr('today').indexOf('-') > -1){
                                    formatZeroDate = values.map((v,i) => getFormatZero(v.value)+['년', '월', '일'][i]).join(' ')
                                    //formatZeroDate = values.map((v,i) => v.value+['년', '월', '일'][i]).join(' ')
                                }else{
                                    formatZeroDate = values.map((v) => getFormatZero(v.value)).join('.')
                                    //formatZeroDate = values.map((v) => v.value).join('.')
                                }
                            } else {
                                formatZeroDate = values.map((v) => getFormatZero(v.value)).join('.')
                                //formatZeroDate = values.map((v) => v.value).join('.')
                            }

                            this.$el.find('.ui-text-del').val(formatZeroDate)
                        }
                    })
                }

                if (this.$el.attr('data-date') === 'YYMMDDH1') {
                    this.dateDataType = ['YY', 'MM', 'DD', 'H1'];
                    //////console.log('daily??', this.$el, this.$el.data('custom-date'))
                    const fromDate = this.$el.data('from-date') || new Date('2010-01-01');
                    const toDate = this.$el.data('to-date') || new Date();
                    //  c('depth4Data:', this.$el.data('custom-date'))
                    var depth4Data;
                    if(this.$el.data('custom-date')){
                        depth4Data = JSON.parse(this.$el.data('custom-date').replace(/\'/g, '\"'));
                    }else{
                        if (this.$el.attr('date-tmr') == 'true') {
                            depth4Data = this.depth4DataSetting(true);
                        } else {
                            depth4Data = this.depth4DataSetting(false);
                        }
                    }

                    this.setCallback({
                        initFn: () => {
                            if (this.$el.find('.ui-text-del').val().length > 0) {
                                const targetVal = this.$el.find('.ui-text-del').val();
                                this.selectedValues = targetVal.split(unitCheck(targetVal)).map((v) => +v);
                            } else {
                                const fromDataStr = this.$el.data('from-date') || '2010-01-01';
                                this.selectedValues = fromDataStr.split(unitCheck(fromDataStr)).map((v) => +v);
                            }
                            function unitCheck(target){
                                return target.indexOf('.') > -1 ? '.' : '-';
                            }
                            this.setDateSet(fromDate, toDate, depth4Data);
                        },
                        slideChangeFn: (depth, selectedIndex, data, swiper, selectedValues) => {
                            // FETASK-791 이체 운영 개선 23-03-29
                            if (this.$el.attr('data-date') === 'YYMMDDH1' && !this.$el.data('custom-date') && depth != 3){
                                if (depth == 0 ) {
                                    depth4Data = this.depth4DataSetting(false);
                                    this.setDateSet(fromDate, toDate, depth4Data);
                                    this.setSwiperSlideTo(1, 0);
                                    this.setSwiperSlideTo(2, 0);
                                    this.setSwiperSlideTo(3, 0);
                                    
                                } else {
                                    if (selectedValues[1].value == fromDate.split('-')[1] && selectedValues[2].value == fromDate.split('-')[2] ) {
                                        depth4Data = this.depth4DataSetting(false);
                                        this.setDateSet(fromDate, toDate, depth4Data);
                                    } else {
                                        if (data == undefined && selectedValues[0].value == fromDate.split('-')[0]) {
                                            depth4Data = this.depth4DataSetting(false);
                                            setTimeout(() => {
                                                this.setDateSet(fromDate, toDate, depth4Data);
                                            }, 2);
                                        } else {
                                            depth4Data = this.depth4DataSetting(true)
                                            this.setDateSet(fromDate, toDate, depth4Data);
                                        }
                                    }
                                    this.setSwiperSlideTo(3, 0);
                                }

                            }

                        },
                        exportFn: (values) => {
                            let formatZeroDate

                            formatZeroDate = values.splice(0, 3).map((v) => getFormatZero(v.value)).join('.')
                            //formatZeroDate = values.splice(0, 3).map((v) => v.value).join('.')
                            formatZeroDate += ' ' + values[0].value;


                            this.$el.find('input[readonly]').val(formatZeroDate)
                        }
                    })
                }

                this.$el.data('cols', this.dateDataType.length);
            }

            // [FETASK-702] 자동이체주기 데이타 설정
            if (this.defaults.item === 'cycle-date') {
                this.setCallback({
                    initFn: () => {
                        if (this.$el.find('.ui-text-del').length <= 0 && this.isHiddenInput) {
                            this.selectedValues = this.$el.find('button .txt-name').text().split(' ');
                        } else {
                            if (this.$el.find('.ui-text-del').val().length > 0 && this.$el.find('.ui-text-del').val() !=='') {
                                this.selectedValues = this.$el.find('.ui-text-del').val().split(' ');
                            } else {
                                if (this.$el.find('.ui-text-del').next('label').find('.area-desc').length > 0) {
                                    this.selectedValues = this.$el.find('.ui-text-del').next('label')[0].firstChild.textContent.trim().split(' ');
                                } else {
                                    this.selectedValues = this.$el.find('.ui-text-del').next('label').text().split(' ');
                                }
                            }
                        }
                        //console.log('this.selectedValues2', this.selectedValues);
                        var list = this.setDataDepth1(this);
                        this.fillCustomData(0, list);

                        // [FETASK-1050] mode가 change(자동이체 등록/변경)일 경우 slideChangeFn 호출
                        if(this.defaults.mode == 'change' && list.every(v => v.value != '신청안함')){
                            var depth = $(this.swiperInstances[0].$el).index();
                            var data = this.swiperInstances[0].slides.length && $(this.swiperInstances[0].slides[this.swiperInstances[0].activeIndex]).data('data');
                            this.selectedValues[depth] = data || this.selectedValues[depth];
                            if(this.selectedValues[depth].text == '매주'){
                                this.selectedValues[1] = this.selectedValues[1].substr(0,1);
                            }
                            ////console.log('this.selectedValues', this.selectedValues);
                        
                            this.slideChangeFn && this.slideChangeFn.call(this, 0, this.swiperInstances[0].activeIndex, data, this.swiperInstances[0], this.selectedValues);
                        }

                        setTimeout(() => {
                            this.saveSelectedData(this.selectedValues);
                            this.activeSwiperValue = this.selectedValues[0].text;
                            this.cloneSelectedValues = [...this.selectedValues];
                        });
                    },
                    slideChangeFn: (depth, selectedIndex, data, swiper, selectedValues) => {
                        var that = this;
                        if (depth === 0) {
                            var list = this.setDataDepth2(selectedValues, this);
                            ////console.log('list2', list)
                            this.fillCustomData(1, list);
                        };
                    },
                    exportFn: (values) => {    
                        // [FETASK-1050] mode가 change(자동이체 등록/변경)일 경우
                        if(this.defaults.mode === 'change'){
                            if (this.$el.find('.ui-text-del').length <= 0 && this.isHiddenInput) {
                                if (values[1] !== undefined && values[0].text !== values[1].text) {                                
                                    this.$el.find('button .txt-name').text(values[0].text + ' ' + values[1].text)
                                } else {
                                    this.$el.find('button .txt-name').text(values[0].text)
                                }
                            } else {                        
                                if (values[1] !== undefined && values[0].text !== values[1].text) {
                                    values[0].text == '매주' ? this.$el.find('.ui-text-del').val(values[0].text + ' ' + values[1].text + '요일') : this.$el.find('.ui-text-del').val(values[0].text + ' ' + values[1].text);
                                } else {
                                    this.$el.find('.ui-text-del').val(values[0].text)
                                }
                            }
                        }
                        this.selectedValues = values;
                    }
                })
            }
           
            this.cycleDateTabAction('init'); // [CHPFMTASK-2128] TAB + DateSpinner 조합일 경우 2015.04.16

            // [FETASK-1555] ampm 데이타 설정
            if (this.defaults.item === 'ampm-date' && this.defaults.itemCustom == undefined) {
                this.setCallback({
                    initFn: () => {
                        if (this.$el.find('.ui-text-del').length <= 0 && this.isHiddenInput) {
                            this.selectedValues = this.$el.find('button .txt-name').text().split(' ');
                        } else {
                            if (this.$el.find('.ui-text-del').val().length > 0 && this.$el.find('.ui-text-del').val() !=='') {
                                this.selectedValues = this.$el.find('.ui-text-del').val().split(' ');
                            } else {
                                if (this.$el.find('.ui-text-del').next('label').find('.area-desc').length > 0) {
                                    this.selectedValues = this.$el.find('.ui-text-del').next('label')[0].firstChild.textContent.trim().split(' ');
                                } else {
                                    this.selectedValues = this.$el.find('.ui-text-del').next('label').text().split(' ');
                                }
                            }
                        }
                        if (this.$el.attr('data-time') != undefined) { // 240704   오전/오후 버튼 타입   data-time="오전 3시"  타입으로 속성추가 
                            //console.log(this.$el.attr('data-time'))
                            this.selectedValues = this.$el.attr('data-time').split(' ');
                        }

                        this.openCallbackAction()

                        var list = this.setDataAmPmDepth1(this);
                        this.fillCustomData(0, list);

                        setTimeout(() => {
                            this.saveSelectedData(this.selectedValues);
                            this.activeSwiperValue = this.selectedValues[0].text;
                            this.cloneSelectedValues = [...this.selectedValues];
                            //halfTime = 
                            this.fillCustomData(1, this.halfTime)
                        });
                    },
                    slideChangeFn: (depth, selectedIndex, data, swiper, selectedValues) => {
                        var that = this;
                    },
                    exportFn: (values) => {
                        this.selectedValues = values;
                        this.$el.find('.ui-text-del').val(this.selectedValues[0].text +' '+ this.selectedValues[1].text);
                        this.$el.find('.ui-text-del').attr('value', this.selectedValues[0].text +' '+ this.selectedValues[1].text);
                        console.log('values',values)
                    }
                })

                //console.log('3333333', this.selectedValues);
                this.selectedValues = [...this.selectedValues, ]
            }
            // console.log(this.$el.data('cols') ,this.$el.data('cols'))

            // for (let i = 1; i <= this.$el.data('cols'); i++) {
            //     this.swiperIds.push(`ui-custom-${i}`);
            //     this.arrData[i-1] = this.arrData[i-1] || [];
            //     console.log('aaaaaaaaaaaaa' , this.arrData)
            // }
            // if (this.defaults.item === 'cycle-date-tab') {
            //     console.log('123')
            //     this.arrData.splice(3,0,'sdadasd')
            // }
            if (this.defaults.item === 'cycle-date-tab') {
                for (let i = 1; i <= this.$el.data('cols') + 1; i++) {
                    this.swiperIds.push(`ui-custom-${i}`);
                    this.arrData[i-1] = this.arrData[i-1] || [];
                }
                
            } else {
                for (let i = 1; i <= this.$el.data('cols'); i++) {
                    this.swiperIds.push(`ui-custom-${i}`);
                    this.arrData[i-1] = this.arrData[i-1] || [];
                }
            }

            
            if (this.defaults.case != undefined) {
                this.$popup.attr('case',this.defaults.case)
            }

            /*! s: FETASK-a11y page DateSpinner 옵션 수정 v.1.0.0 */
            const isA11yCheck = isA11yCheckVersion();
            /*! e: FETASK-a11y page DateSpinner 옵션 수정 v.1.0.0 */

            this.$popup.attr('type-slideview',this.defaults.slideView);
            this.swiperIds.forEach((id, index) => {
                this.$popup.find('.group-spinner').append(getBottomLayerSwiperTmpl(id));
                // this.selectedValues[index] = this.fillCustomData(index, this.arrData[index]);
              
                setTimeout(() => {
                    /*! s: FETASK-a11y page DateSpinner 옵션 수정 v.1.0.0 */
                    if(isA11yCheck){
                        this.options = {...this.options, observer:true, observeParents:true, preventClicks: false, preventClicksPropagation: false };
                    }
                    /*! e: FETASK-a11y page DateSpinner 옵션 수정 v.1.0.0 */
                    const swiper = new Swiper(this.$popup.find('.' + id)[0], {
                        ...this.options,
                        slidesPerView:this.defaults.slideView,
                        on: {
                            init: (sw) => {
                                if(isA11yCheck){
                                    try {
                                        sw.wrapperEl.addEventListener('click', (e) => {
                                            const swipe = sw;
                                            
                                            const {target} = e;
                                            const targetindex = $(target).parent().index();

                                            swipe.slideTo(targetindex, 300);
                                        });   
                                    } catch (error) {
                                        throw new Error(`swiper init ${error}`)
                                    }
                                }
                            },
                            afterInit: (sw) => {
                                if(isA11yCheck){
                                    $(document).ready(() => {
                                        setTimeout(() => {
                                            try {
                                                const depth = $(sw.$el).index();
                                                const isActive = sw?.activeIndex;
                                                const slidesEle = sw?.slides;
                                                const ulWrap = sw?.$wrapperEl;
                                                const maxLength = sw?.$wrapperEl[0].children?.length;
        
                                                const minValue = this?.arrData[depth][0];
                                                const maxValue = this?.arrData[depth][slidesEle?.length-1];
                                                const valueNow = this?.arrData[depth][isActive];
        
                                                //버튼 절대 좌표값 계산
                                                const getPageOffset = window.pageYOffset;
                                                const swipeDivBox = ulWrap[0].parentElement;
                                                const ulGetBoundRect = swipeDivBox.getBoundingClientRect();
                                                const { top, width, bottom } = ulGetBoundRect;
                                                const buttonHeight = 40;
        
                                                const topOffset = top - buttonHeight
                                                const bottomOffset = bottom;
                
                                                const prevBtn = document.createElement('button');
                                                const nextBtn = document.createElement('button');

                                                prevBtn.classList.add('control-btn');
                                                prevBtn.classList.add('prev__btn');
                                                
                                                prevBtn.setAttribute('role','button');
                                                prevBtn.setAttribute('style', `${!width && 'visibility:hidden'};position:fixed;top:${topOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:5;`);                                    
                                                
                                                prevBtn.setAttribute('aria-label', `${valueNow?.text}, 이전 (감소 버튼)`);
                                                
                                                ulWrap[0].setAttribute('role','presentation');
                                                ulWrap[0]?.before(prevBtn);
                                                ulWrap[0]?.after(nextBtn);

                                                const $SwiperTarget = $(sw.$el).find('.swiper-wrapper');

                                                // TODO - aria-disabled
                                                if(isActive === 0){
                                                    $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'true');
                                                }else{
                                                    $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');
                                                }
        
                                                $(swipeDivBox).find('.prev__btn')?.on('click.spinnerSwiper', (e) => {
                                                    const swipe = sw;
                                                    const {activeIndex} = swipe;

                                                    const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex - 1);

                                                    isDateSpinnerNextTextForceReading(e.currentTarget, slidesEles?.text());

                                                    setTimeout(() => {
                                                        const currentIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();
                                    
                                                        // TODO - aria-disabled
                                                        if(currentIndex - 1 === 0){
                                                            $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'true');
                                                        }else{
                                                            $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');
                                                        }
                                                        $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'false');

                                                        if(currentIndex - 1 === 0) return;
                                                    });

                                                    swipe.slideTo(activeIndex - 1, 300);

                                                    //spinner변경 텍스트
                                                    setTimeout(() => {
                                                        let currentText = '';

                                                        const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');
                                        
                                                        activeItems?.each((idx,list) => {
                                                            currentText += list.innerText;
                                                            currentText += ' ';
                                                        });
                                        
                                                        setTimeout(() => {
                                                            const selectDiv = document.querySelector('.spinner-live');
                                        
                                                            const createText = document.createElement('div');
                                                            createText.innerText = `${currentText} 선택`;
                                                            
                                                            $(selectDiv)?.children().remove();
                                        
                                                            ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);
                                        
                                                            setTimeout(() => {
                                                                createText.remove();
                                                            },2000);
                                                        },1000);
                                                    },500);
                                                });

                                                nextBtn.classList.add('control-btn');
                                                nextBtn.classList.add('next__btn');
        
                                                nextBtn.setAttribute('role','button');
                                                nextBtn.setAttribute('style', `${!width && 'visibility:hidden'};position:fixed;top:${bottomOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:5;`);
                                               
                                                nextBtn.setAttribute('aria-label', `${valueNow?.text}, 다음 (증가 버튼)`);
        
                                                $(swipeDivBox).find('.next__btn')?.on('click.spinnerSwiper', (e) => {
                                                    const swipe = sw;
                                                    const {activeIndex} = swipe;

                                                    const maxLength = $(e.currentTarget).parent().find('.swiper-slide')?.length;

                                                    const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex + 1);

                                                    isDateSpinnerNextTextForceReading(e.currentTarget, slidesEles?.text());

                                                    

                                                    setTimeout(() => {
                                                        const currentIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();
                                    
                                                        // TODO - aria-disabled
                                                        if(currentIndex === maxLength -1){
                                                            $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'true');
                                                        }else{
                                                            $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'false');
                                                        }
                                                        $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');

                                                        if(currentIndex === maxLength -1) return;
                                                    });

                                                    swipe.slideTo(activeIndex + 1, 300);

                                                    //spinner변경 텍스트
                                                    setTimeout(() => {
                                                        let currentText = '';

                                                        const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');
                                        
                                                        activeItems?.each((idx,list) => {
                                                            currentText += list.innerText;
                                                            currentText += ' ';
                                                        });
                                        
                                                        setTimeout(() => {
                                                            const selectDiv = document.querySelector('.spinner-live');
                                        
                                                            const createText = document.createElement('div');
                                                            createText.innerText = `${currentText} 선택`;
                                                            
                                                            $(selectDiv)?.children().remove();
                                        
                                                            ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);
                                        
                                                            setTimeout(() => {
                                                                createText.remove();
                                                            },2000);
                                                        },1000);
                                                    },500);
                                                });

                                                setTimeout(() => {
                                                    $(swipeDivBox).find('.prev__btn').each((idx, item) => {
                                                        if(idx > 0){
                                                            $(item).remove();
                                                        }
                                                    });
    
                                                    $(swipeDivBox).find('.next__btn').each((idx, item) => {
                                                        if(idx > 0){
                                                            $(item).remove();
                                                        }
                                                    });
                                                },500);

                                                isA11ySwiperBtnChangeAria(); //스와이프 버튼 aria-hidden
    
                                                const closeBtns = this?.$popup[0]?.querySelectorAll('.close-btn');
                                                closeBtns && closeBtns.forEach((list,idx) => {
                                                    if(idx > 0){
                                                        list.remove();
                                                    }
                                                    $(list).off(`click${this.eventId}`).on(`click${this.eventId}`,() => {
                                                        this.isA11ySelectTypeAcess();
                                                    });
                                                });
                                            }catch(error){
                                                throw new Error(`swiper afterInit ${error}`)
                                            }
                                        }, 1000);
                                    });
                                }
                            },
                            update: (sw) => {
                            },
                            slideChange: (sw) => {
                                const depth = $(sw.$el).index();                                
                                const data = $(sw.slides[sw.activeIndex]).data('data');

                                this.selectedValues[depth] = data || this.selectedValues[depth];
                                this.slideChangeFn && this.slideChangeFn.call(this, depth, sw.activeIndex, data, sw, this.selectedValues)

                            },
                            slideChangeTransitionEnd: (sw) =>{
                                if(isA11yCheck){
                                    setTimeout(()=>{
                                        this.isA11ySwipeList();
                                        this.isA11ySwipePrevNextButton(sw);
                                        this.isA11yAddInputArea(sw, 'change');
                                    },100)
                                }
                            }
                        }
                    });
                    this.$popup.find('.' + id).data('swiper', swiper);

                    this.swiperInstances.push(swiper);   
                })
            })

            /*! s: FETASK-a11y page v.1.0.0 */
            if(isA11yCheck){
                //접근성 팝업 닫기버튼 추가
                this.isA11yAddCloseBtn();
                //spinner aria-live 영역 만들기
                this.isA11ySpinnerLive('create');

                //spinner disabled 체크해서 막기
                //this.isA11yCheckDisabled();
            }
            /*! se: FETASK-a11y page v.1.0.0 */

            setTimeout(() => {
                this.initFn && this.initFn.call(this);
            });
            if (this.defaults.item == "ampm-date") { //[FETASK-1555] ampm  하단 버튼 설정
                this.$popup.find('.btn-group').addClass('type2')
                this.$popup.find('.btn-group').append(getBottomLayerCountListTmpl('알림 끄기', '알림 설정'));
            } else {
                this.$popup.find('.btn-group').append(getBottomLayerCountListTmpl('', '확인'));
            }

            
            this.update();
        }
        // this.openMotion();
    }
    /**
     * data-item="ampm-date"
     * @returns {array} ex) [{text:'1시', value:''010000}, {text:'2시', value:'020000'}]
     * @example
     * $('.ui-input').data('ui').getDataAm(); 
     */
    getDataAm(){
        return Array.from({ length: 11 }).map(function(_, index) {
            var num = index + 1;
            var textValue = num + "시";
            var valueValue = ("0" + num).slice(-2) + "0000";
            return {text: textValue, value: valueValue};
        });
    }

    /**
     * data-item="cycle-date-tab" (TAB + DateSpinner 조합:자동충전)일경우 실행되는 함수
     * @param init {string} data초기값 설정
     * @param reset {string} data값 재설정
     * @param update {string} data값 update
     * @param event {string} tab 클릭시 발생하는 event
     * @example
     * this.cycleDateTabAction('init'); //data초기값 설정
     * this.cycleDateTabAction('reset'); //data값 재설정
     * this.cycleDateTabAction('update'); //data값 update
     * this.cycleDateTabAction('event'); //tab 클릭시 발생하는 event 
     */

    // [CHPFMTASK-2128] TAB + DateSpinner 조합일 경우 2015.04.16
    cycleDateTabAction(type='init'){
        if (this.defaults.item != 'cycle-date-tab') return;



        // var tabInfo = ['매달','매주','매일'];
        var tabInfo = this.setTabInfo(this);
        var listDay = this.setDataDay(this);
        var listWeek = this.setDataWeek(this);
        var listAmPm = this.setDataAmPmDepth1(this);
        var listHour = this.setDataHour(this);

        console.log('cycleDateTabAction')
        if (this.defaults.item != 'cycle-date-tab'){
            console.log('cycle-date-tab')
            if(this.$popup) {
                console.log('$popup')
                this.$popup.find(".ui-custom-1").css('width','auto');
                this.$popup.find(".ui-custom-1").css('visibility','hidden');
            }
        }

        if(type === 'reset'){
            console.log('reset!!!')
            this.$el.removeClass('done');
            this.$el.find('input').attr('value', '');
            this.$el.find('input').val('');
           
            if (this.$el.find('input').val() !== '') {
                console.log('dataReset');
                this.dataReset();
            }
            
            if(this.$popup) {
                // console.log('this.selectedValues', this.selectedValues);
                // this.$popup.find(".ui-custom-1").css('display','none');
                this.$popup.find(`.swiper-container`).show();
                this.$popup.find(`.swiper-wrapper`).children().remove();
                this.fillCustomData(0, tabInfo);
                this.fillCustomData(1, listDay);
                this.fillCustomData(2, listAmPm);
                this.fillCustomData(3, listHour);
                
                this?.$popup?.find('.toggle-list-col .toggle-item').removeClass('active');
                this?.$popup?.find('.toggle-list-col .toggle-item').eq(0).addClass('active');

                if (this.$el.find('input').val() == '') {
                    console.log('초기값변경');
                    this.$popup.find(".ui-custom-2").css('display','block');
                   
                    // CHPFMTASK-2418 충전주기 초기화 추가요건
                    const today = new Date();
                    const todayDate = today.getDate(); // 오늘일자
                    const todayDateVal = todayDate - 1; // 실제오늘일자
                    const ampmeVal = 1; // 오후
                    const DataHourIndex = 2 //3시

                    setTimeout(() => {
                        this.swiperInstances[1].slideTo(todayDateVal) // 오늘일자로 세팅
                        this.swiperInstances[2].slideTo(ampmeVal)
                        this.swiperInstances[3].slideTo(DataHourIndex)
                    },300);
                }
            }
        }

        if(type === 'update'){
            console.log('update!!!')
           
            if (this.$el.find('input').val() !== '') {
                setTimeout(()=>{
                    this.dataReset();
                })
            }
            if(this.$popup) {
                if (this.$el.find('.ui-text-del').length <= 0 && this.isHiddenInput) {
                    this.selectedValues = this.$el.find('button .txt-name').text().split(' ');
                } else {
                    if (this.$el.find('.ui-text-del').val().length > 0 && this.$el.find('.ui-text-del').val() !=='') {
                        // this.selectedValues = this.$el.find('.ui-text-del').val().split(' ');
                        // if(this.selectedValues[0] == '매일' && this.selectedValues[1] !== ''){
                        //     console.log('매일예외처리')
                        //     this.selectedValues[3] = this.selectedValues[2];
                        //     this.selectedValues[2] = this.selectedValues[1];
                        //     this.selectedValues[1] = '';
                        // }
                        const valueArray = this.$el.find('.ui-text-del').val().split(' ');
                        if(!valueArray[1].includes('일') && valueArray[1] != '') valueArray.splice(1,0,'');
                        this.selectedValues = valueArray;
                        
                    } else {
                        if (this.$el.find('.ui-text-del').next('label').find('.area-desc').length > 0) {
                            this.selectedValues = this.$el.find('.ui-text-del').next('label')[0].firstChild.textContent.trim().split(' ');
                        } else {
                            this.selectedValues = this.$el.find('.ui-text-del').next('label').text().split(' ');
                        }
                        console.log('update:reset')
                        this.cycleDateTabAction('reset');
                    }
                }
                
                if(this.selectedValues[0] == '매달'){
                    this?.$popup?.find('.toggle-list-col .toggle-item').removeClass('active');
                    this?.$popup?.find('.toggle-list-col .toggle-item').eq(0).addClass('active');
                   
                    setTimeout(() => {
                        this.fillCustomData(0, tabInfo);
                        this.fillCustomData(1, listDay);
                        this.fillCustomData(2, listAmPm);
                        this.fillCustomData(3, listHour);
                    },50);

                    this.$popup.find(".ui-custom-2").css('display','block');

                    const monthVal0 = this.selectedValues[0]
                    const monthVal1 = this.selectedValues[1]
                    const monthVal2 = this.selectedValues[2]
                    const monthVal3 = this.selectedValues[3]

                    const tabIndex = tabInfo.findIndex(item => item.value === monthVal0)
                    const DataDayIndex = listDay.findIndex(item => item.value === monthVal1)
                    const DataAmpmIndex = listAmPm.findIndex(item => item.value === monthVal2)
                    const DataHourIndex = listHour.findIndex(item => item.value === monthVal3)

                    console.log('DataDayIndex',DataDayIndex)

                    setTimeout(() => {
                        this.swiperInstances[0].slideTo(tabIndex)
                        this.swiperInstances[1].slideTo(DataDayIndex)
                        this.swiperInstances[2].slideTo(DataAmpmIndex)
                        this.swiperInstances[3].slideTo(DataHourIndex)
                        
                    },100);
                    
                } else if(this.selectedValues[0] == '매주'){
                    this?.$popup?.find('.toggle-list-col .toggle-item').removeClass('active');
                    this?.$popup?.find('.toggle-list-col .toggle-item').eq(1).addClass('active');
                   
                    setTimeout(() => {
                        this.fillCustomData(0, tabInfo);
                        this.fillCustomData(1, listWeek);
                        this.fillCustomData(2, listAmPm);
                        this.fillCustomData(3, listHour);
                    },50);

                    this.$popup.find(".ui-custom-2").css('display','block');
                    
                    const weekVal0 = this.selectedValues[0]
                    const weekVal1 = this.selectedValues[1]
                    const weekVal2 = this.selectedValues[2]
                    const weekVal3 = this.selectedValues[3]
                    
                    const tabIndex = tabInfo.findIndex(item => item.value === weekVal0)
                    const DataWeekIndex = listWeek.findIndex(item => item.value === weekVal1)
                    const DataAmpmIndex = listAmPm.findIndex(item => item.value === weekVal2)
                    const DataHourIndex = listHour.findIndex(item => item.value === weekVal3)
                    
                    setTimeout(() => {
                        this.swiperInstances[0].slideTo(tabIndex)
                        this.swiperInstances[1].slideTo(DataWeekIndex)
                        this.swiperInstances[2].slideTo(DataAmpmIndex)
                        this.swiperInstances[3].slideTo(DataHourIndex)
                    },100);
                
                } else if(this.selectedValues[0] == '매일'){
                    this?.$popup?.find('.toggle-list-col .toggle-item').removeClass('active');
                    this?.$popup?.find('.toggle-list-col .toggle-item').eq(2).addClass('active');
                    setTimeout(() => {
                        this.fillCustomData(0, tabInfo);
                        this.fillCustomData(1, []);
                        this.fillCustomData(2, listAmPm);
                        this.fillCustomData(3, listHour);
                    },50);
                    
                    this.$popup.find(".ui-custom-2").css('display','none');

                    const dayVal0 = this.selectedValues[0]
                    const dayVal1 = this.selectedValues[1]
                    const dayVal2 = this.selectedValues[2]
                    const dayVal3 = this.selectedValues[3]
                    

                    const tabIndex = tabInfo.findIndex(item => item.value === dayVal0)
                    const DataAmpmIndex = listAmPm.findIndex(item => item.value === dayVal2)
                    const DataHourIndex = listHour.findIndex(item => item.value === dayVal3)
                    

                    setTimeout(() => {
                        this.swiperInstances[0].slideTo(tabIndex)
                        this.swiperInstances[2].slideTo(DataAmpmIndex)
                        this.swiperInstances[3].slideTo(DataHourIndex)
                        
                    },100);
                }
                this.$popup.find(".ui-custom-1").css('width','auto');
                this.$popup.find(".ui-custom-1").css('visibility','hidden');
            }
        }
    
        if(type === 'init'){
            console.log('init!!!')
            
            this.setCallback({
                initFn: () => {
                    if (this.$el.find('.ui-text-del').length <= 0 && this.isHiddenInput) {
                        this.selectedValues = this.$el.find('button .txt-name').text().split(' ');
                    } else {
                        if (this.$el.find('.ui-text-del').val().length > 0 && this.$el.find('.ui-text-del').val() !=='') {
                            // this.selectedValues = this.$el.find('.ui-text-del').val().split(' ');
                            // console.log('aaaa' , this.selectedValues)
                            // if(this.selectedValues[0] == '매일' && this.selectedValues[1] !== ''){
                            //     console.log('매일예외처리')
                            //     this.selectedValues[3] = this.selectedValues[2];
                            //     this.selectedValues[2] = this.selectedValues[1];
                            //     this.selectedValues[1] = '';
                            // }

                            const valueArray = this.$el.find('.ui-text-del').val().split(' ');
                            
                            if(!valueArray[1].includes('일') && valueArray[1] != '') valueArray.splice(1,0,'');
                            this.selectedValues = valueArray;
                        } else {
                            
                            if (this.$el.find('.ui-text-del').next('label').find('.area-desc').length > 0) {
                                this.selectedValues = this.$el.find('.ui-text-del').next('label')[0].firstChild.textContent.trim().split(' ');
                            } else {
                                this.selectedValues = this.$el.find('.ui-text-del').next('label').text().split(' ');
                            }
                            
                        }
                    }
                    // console.log('this.selectedValues1', this.selectedValues);
    
                    this.fillCustomData(0, tabInfo);
                    this.fillCustomData(1, listDay);
                    this.fillCustomData(2, listAmPm);
                    this.fillCustomData(3, listHour);

                    setTimeout(() => {
                        this.saveSelectedData(this.selectedValues);
                        this.activeSwiperValue = this.selectedValues[0];
                        this.cloneSelectedValues = [...this.selectedValues];
                    });
                },
                exportFn: (values) => {
                    this.selectedValues = values;

                    const tabTitle = this?.$popup?.find('.toggle-list-col .toggle-item.active a').attr('title');
                    // console.log(tabTitle, values[0].text, values[1].text, values[2].text)
                    if(values[1].text.length > 0){
                        this.$el.find('.ui-text-del').val(values[0].text+ ' ' + values[1].text+ ' ' + values[2].text+ ' ' + values[3].text)
                    } else {
                        this.$el.find('.ui-text-del').val(values[0].text+ ' ' + values[2].text+ ' ' + values[3].text)
                    }
                }
            });

            // this.dataReset();
        }
    
        if(type === 'event'){
            console.log('event!!!')
            const _this = this, _popup = _this.$popup, toggleItem = _popup.find('.toggle-list-col .toggle-item');
            if(this.selectedValues?.length < 5) {
                // this.dataReset();  
            }

            
            toggleItem.off('click.tabarea').on('click.tabarea',function(e){
                _this.dataReset();  
                
                const tabIdx = $(this).index() - 1;
                setTimeout(() => {
                    _this.swiperInstances[0].slideTo(tabIdx)
                },100);

                // CHPFMTASK-2418 충전주기 초기화 추가요건
                const today = new Date();
                const todayDate = today.getDate(); // 오늘일자
                const todayDateVal = todayDate - 1; // 오늘일자
                const ampmeVal = 1; // 오후
                const DataHourIndex = 2 //3시
                const dayOfWeekNum = today.getDay(); // 오늘요일
                let realWeekNum;

                if (dayOfWeekNum == '0'){
                    realWeekNum = dayOfWeekNum + 6
                } else {
                    realWeekNum = dayOfWeekNum - 1
                }

                // 케이스별 데이터 설정
                if(tabIdx === 0){ // 매달
                    _this.fillCustomData(0, tabInfo);
                    _this.fillCustomData(1, listDay);
                    _this.fillCustomData(2, listAmPm);
                    _this.fillCustomData(3, listHour);
                   
                    // CHPFMTASK-2418 충전주기 초기화 추가요건
                    setTimeout(() => {
                        _this.swiperInstances[1].slideTo(todayDateVal) // 오늘일자로 세팅
                        _this.swiperInstances[2].slideTo(ampmeVal)
                        _this.swiperInstances[3].slideTo(DataHourIndex)
                    },300);
                    
                } else if(tabIdx === 1){ // 매주
                    _this.fillCustomData(0, tabInfo);
                    _this.fillCustomData(1, listWeek);
                    _this.fillCustomData(2, listAmPm);
                    _this.fillCustomData(3, listHour);

                    // CHPFMTASK-2418 충전주기 초기화 추가요건
                    setTimeout(() => {
                        _this.swiperInstances[1].slideTo(realWeekNum) // 오늘요일로 세팅
                        _this.swiperInstances[2].slideTo(ampmeVal)
                        _this.swiperInstances[3].slideTo(DataHourIndex)
                    },300);

                } else if(tabIdx === 2){ // 매일
                    _this.fillCustomData(0, tabInfo);
                    _this.fillCustomData(1, []);
                    _this.fillCustomData(2, listAmPm);
                    _this.fillCustomData(3, listHour);

                    // CHPFMTASK-2418 충전주기 초기화 추가요건
                    setTimeout(() => {
                        _this.swiperInstances[2].slideTo(ampmeVal)
                        _this.swiperInstances[3].slideTo(DataHourIndex)
                    },300);
                }
                
                // setTimeout(() => {
                //     _this.saveSelectedData(_this.selectedValues);
                //     _this.activeSwiperValue = _this.selectedValues[0].text;
                //     _this.cloneSelectedValues = [_this.selectedValues];
                // });
                
                $('.swiper-container').each(function() {
                    if($(this).children('ul').find("li").length === 0 ){
                        $(this).css('display','none');
                        // $(this).attr('aria-hidden','true');
                    } else {
                        $(this).css('display','block');
                        // $(this).attr('aria-hidden','false');
                    }
                });
            });
        }
    }


    // [FETASK-702] 자동이체주기 data-lists 옵션 설정
    setDataDepth1(obj){
        const { unselectedText } = obj.$el[0].dataset;
        const defaultItems = [
            {
                text: unselectedText || '신청안함',
                value: unselectedText || '신청안함'
            },
            {
                text: '매월',
                value: '매월'
            },
            {
                text: '매주',
                value: '매주'
            },
            {
                text: '매일',
                value: '매일'
            }
        ];

        this.defaultLists = obj.$el[0].dataset.lists && JSON.parse(obj.$el[0].dataset.lists.replace(/'/g, "\""));

        if(this.defaultLists && this.defaultLists.length){  
            // [FETASK-1050] mode가 change(자동이체 등록/변경)일 경우 '신청안함' 제거
            this.defaults.mode == 'change' ? defaultItems.splice(0) : defaultItems.splice(1, 3);
            this.defaultLists.forEach(list => defaultItems.push({ text: list, value: list }));
        }

        return defaultItems;
    }

    // [FETASK-702] 자동이체주기 2depth 데이타설정
    setDataDepth2(values, obj) {
        const selectedItem = values[0]?.value;
        if (selectedItem === '매월') {
            const days = []
            for(let i = 0; i < 31; i++) {
                const daysItem = {text: `${i+1}일`, value: `${i+1}일`};
                days.push(daysItem);
            }
            // 말일 추가
            if (obj.defaults.cycleLatest == true) {
                days.push({text: "말일", value: "32일"});
            }

            return days;
        } else if (selectedItem === '매주') {
            const week = ['월', '화', '수', '목', '금', '토', '일'];
            const weekSwiper = [];

            for(let i = 0; i < week.length; i++) {
                const weekItem = {text: `${week[i]}`, value: `${week[i]}`};
                weekSwiper.push(weekItem);
            }
            return weekSwiper;
        } else if (selectedItem === '매일') {
            return ['매일'];
        }
    }

    // [CHPFMTASK-2128] 일별세팅 2015.04.04
    setTabInfo(obj){
       
        const tabGroup = []
        for(let i = 0; i < 3; i++) {
            let eqNum = i + 1
            const tabTitle = ['매달','매주','매일'];
            const tabTitleItem = {text: `${tabTitle[i]}`, value: `${tabTitle[i]}`};
            tabGroup.push(tabTitleItem);
        }

        return tabGroup;
    }

    // [CHPFMTASK-2128] 일별세팅 2015.04.04
    setDataDay(obj){
        // return defaultItems;
        const days = []
        for(let i = 0; i < 31; i++) {
            const daysItem = {text: `${i+1}일`, value: `${i+1}일`};
            days.push(daysItem);
        }
        // 말일 추가
        if (obj.defaults.cycleLatest == true) {
            days.push({text: "말일", value: "32일"});
        }

        return days;
    }
    // [CHPFMTASK-2128] 요일별세팅 2015.04.04
    setDataWeek(obj) {

        const defaultItems = [
            
            {
                text: '월요일',
                value: '월요일'
            },
            {
                text: '화요일',
                value: '화요일'
            },
            {
                text: '수요일',
                value: '수요일'
            },
            {
                text: '목요일',
                value: '목요일'
            },
            {
                text: '금요일',
                value: '금요일'
            },
            {
                text: '토요일',
                value: '토요일'
            },
            {
                text: '일요일',
                value: '일요일'
            }
        ];

        return defaultItems;
    }
    // [CHPFMTASK-2128] 시간별세팅 2015.04.04
    setDataHour(obj) {

        const defaultItems = [
            {
                text: '1시',
                value: '1시'
            },
            {
                text: '2시',
                value: '2시'
            },
            {
                text: '3시',
                value: '3시'
            },
            {
                text: '4시',
                value: '4시'
            },
            {
                text: '5시',
                value: '5시'
            },
            {
                text: '6시',
                value: '6시'
            },
            {
                text: '7시',
                value: '7시'
            },
            {
                text: '8시',
                value: '8시'
            },
            {
                text: '9시',
                value: '9시'
            },
            {
                text: '10시',
                value: '10시'
            },
            {
                text: '11시',
                value: '11시'
            },
            {
                text: '12시',
                value: '12시'
            }
        ];

        return defaultItems;
    }
    // [FETASK-1555] ampm 옵션 설정
    setDataAmPmDepth1(obj){

        const defaultItems = [
            {
                text: '오전',
                value: '오전'
            },
            {
                text: '오후',
                value: '오후'
            }
        ];

        //this.defaultLists = obj.$el[0].dataset.lists && JSON.parse(obj.$el[0].dataset.lists.replace(/'/g, "\""));
        return defaultItems;
    }
    // [FETASK-702] 20230315 데이타동적 변경시 데이타설정 
     /**
     * @summary데이타동적 변경시 데이타설정
     * @param {Array} values 넣어줄 value
     * @example 
     * $('#test01').data('ui').refreshSetValues([2022, 1, 1]);
     * $('#custom1').data('ui').refreshSetValues(['aa']);
     */
    refreshSetValues(values){
        console.log('refreshSetValues')
        if (this.defaults.item === 'cycle-date') {
            this.setCallback({
                initFn: () => {
                    const list = this.setDataDepth1(this);

                    if(values[0] === '매월'){
                        this.fillCustomData(0, list);  
                        return false;
                    } 

                    if(values[0] === '매주'){
                        this.selectedValues = [];
                        values.length && values.forEach((value, index) => {
                            if(index == 0){
                                this.selectedValues.push({ text: value, value: value });
                            }
                            if(this.$el.hasClass('prd-input') && index == 1){
                                this.selectedValues.push({ text: value, value: value });
                            }
                        });  
                        this.fillCustomData(0, list);  

                        setTimeout(() => {
                            const list2 = this.setDataDepth2(this.selectedValues, this);
                            if(this.defaults.lists){
                                const filteredValue = ['매일', '매주', '신청안함'].some(v => v === this.activeSwiperValue);
                                if(filteredValue) return false;

                                // activeSwiperValue가 '매월'인 경우만 '매주 0요일'로 설정
                                const setData = this.getToday(this.selectedValues[0].value);
                                this.selectedValues = this.setSelectedData.apply(null, setData);  
                                this.activeSwiperValue = this.selectedValues[0].text;
                                this.cloneSelectedValues = [...this.selectedValues];
                                this.saveSelectedData(this.selectedValues);
                            }
                            this.fillCustomData(1, list2);
                        })    
                    }
                },
                slideChangeFn: (depth, selectedIndex, data, swiper, selectedValues) => {
                    if (depth === 0) {
                        var list = this.setDataDepth2(selectedValues, this);
                        this.fillCustomData(1, list);
                    };
                },
                exportFn: (values) => {  
                }                
            });

            this.initFn.call(this);
        }
        
        //[FETASK-1038] 새로운 selectedValues로 DateSpinner 업데이트 2023-06-05
        if(this.$el.attr('data-date') === 'YYMMDD'){
            ////console.log('refresh values...');
            const fromDate = this.el.dataset.fromDate || new Date('2010-01-01');
            const toDate = this.el.dataset.toDate || new Date('2025-12-31');

            this.setCallback({
                initFn: () => {
                    this.selectedValues = values.map((v) => +v);
                    setTimeout(() => {
                        this.setDateSet(fromDate,toDate);
                    }, 0);
                },
                slideChangeFn: (depth, selectedIndex, data, swiper, selectedValues) => {
                    this.setDateSet(fromDate,toDate);
                },
                exportFn: (values) => {
                    let formatZeroDate;
                    formatZeroDate = values.map((v) => getFormatZero(v.value)).join('.')
                    //formatZeroDate = values.map((v) => v.value).join('.')
                    this.$el.find('.ui-text-del').attr('value', formatZeroDate);
                }                
            });

            this.initFn.call(this);
        }
        //[CHPFMTASK-863] 새로운 selectedValues로 DateSpinner 업데이트 2024-04-26
        if(this.$el.attr('data-date') === 'YYMM'){
            ////console.log('refresh values...');

            const fromDate = this.el.dataset.fromDate || new Date('2010-01-01');
            const toDate = this.el.dataset.toDate || new Date('2025-12-31');

            this.setCallback({
                initFn: () => {
                    this.selectedValues = values.map((v) => +v);
                    setTimeout(() => {
                        // console.log(fromDate,toDate)
                        this.setDateSet(fromDate,toDate);
                    }, 0);
                },
                slideChangeFn: (depth, selectedIndex, data, swiper, selectedValues) => {
                    this.setDateSet(fromDate,toDate);
                },
                exportFn: (values) => {
                    let formatZeroDate;
                    formatZeroDate = values.map((v) => getFormatZero(v.value)).join('.')
                    //formatZeroDate = values.map((v) => v.value).join('.')
                    this.$el.find('.ui-text-del').attr('value', formatZeroDate);
                }                
            });

            this.initFn.call(this);
        }
    }
    // 초기화
    reset(){
        if (type == null) {
            this.selectedValues = [];
            this.swiperInstances.forEach((swiper, depth) => {
                this.fillCustomData(depth, []);
            })
            this.export()
        }
    }
    // 240730  정의헌님 요청  value 값 리셋
    dataReset () {
        // [CHPFMTASK-2128] TAB + DateSpinner 조합이 아닐경우에만 실행 2015.04.04
        if (this.defaults.item !== 'cycle-date-tab') {
            this.$el.removeClass('done');
            this.$el.find('input').val('');
        }
        // [CHPFMTASK-2128] TAB + DateSpinner 조합일 경우 2015.04.04
        if (this.defaults.item === 'cycle-date-tab') {
            this.selectedValues = [];

            for(var i = 0; i < this.swiperIds.length; i++) {
                this.swiperInstances[i].slideTo(0)
            }
        }

        if (this.$el.find('.ui-text-del').attr('today') != undefined) {
            // console.log('??')
            this.selectedValues = this.$el.find('.ui-text-del').attr('today').split('-').map((v) => +v);
            let selectedIndex = []
            for(var i = 0; i < this.selectedValues.length; i++) {
                selectedIndex.push(this.arrData[i].findIndex((obj) => this.selectedValues[i] === obj.value));
            }
            for(var i = 0; i < this.swiperIds.length; i++) {
                this.swiperInstances[i].slideTo(selectedIndex[i])
            }
        } else {
            this.selectedValues = [];
            for(var i = 0; i < this.swiperIds.length; i++) {
                this.swiperInstances[i].slideTo(0)
            }
        }
    }

    // 버튼 활성화
    enable(){
        this.$el.find('button').attr('disabled', false);
    }

    //비활성화
    disable(){
        this.$el.find('button').attr('disabled', true);
    }

    addClassSet(){
        // FETASK-1161 | 230714 | input 비활성화 시 클래스추가 **접근성관련 추후 수정**
        if(this.$el.find('input').attr('disabled') != undefined) {
            this.$el.addClass('disabled');
        } else {
            this.$el.removeClass('disabled');
        }
        // if(this.$el.find('input').attr('readonly') != undefined) {
        //     this.$el.addClass('readonly');
        //     if(isA11yCheckVersion()){
        //         this.$el.attr({'aria-readonly':'true'});
        //     }
        // } else {
        //     this.$el.removeClass('readonly');
        // }
    }
    /**
     * 현재 선택된 값 리턴
     * @returns {array} ex) [{text:'', value:''}, {text:'', value:''}]
     * @example
     * $('.ui-input').data('ui').getValue();
     */
    getValue(){
        return this.selectedValues
    }

    /**
     * setText
     * @param text 바닥페이지에 삽입될 값
     */
    setText(text){
        $customPicker01.find('.txt-name').text(text);
    }

    // 각 피커의 데이터를 삽입
    // @param depth 피커의 위치
    // @param items {array} 해당 데이터 [{text: string, value: string}]
    // @returns {*}

    /**
     * @summary 각 피커의 데이터를 삽입
     * @param {Array<string|number>} values 넣어줄 value
     * @example 
     *  $('.ui-input').data('ui').fillCustomData(0, list);
     */
    fillCustomData(depth, items = []){ // 커스텀데이터 기본
        const id = this.swiperIds[depth];
        // console.log('id = ', id,' / $popup = ',this.$popup);
        this.$popup.find(`.${id} > .swiper-wrapper`).children().remove();

        if(items.length > 0 && typeof items[0] !== 'object'){
            items = items.map((v) => ({text: v, value: v}))
        }

        this.arrData[depth] = items;

        items.forEach((item, idx) => {
            let $item = $(getBottomLayerListTmpl(item.value, '', '', item.text))

            this.$popup.find(`.${id} > .swiper-wrapper`).append($item);
            $item.data('data', item);

            if(typeof this.selectedValues[depth] === 'number' || typeof this.selectedValues[depth] === 'string'){
                let compareAttr;

                
                if(this.$el.data('date')){
                    compareAttr = 'value';
                }else{
                    compareAttr = 'text';
                }
                if(item[compareAttr] === this.selectedValues[depth]){
                    this.selectedValues[depth] = item;
                    
                }
            }
            // if (idx === items.length-1) {
            // [FETASK-702] 타입체크 후 할당
            const selectedValue = typeof this.selectedValues[depth] === 'object' ? this.selectedValues[depth].value : this.selectedValues[depth];
            
            if (item.value === selectedValue) {
                //console.log(item.value, selectedValue)
                // this.$popup.find(`.${id}`)[0].swiper.update();
                this.$popup?.find(`.${id}`)[0]?.swiper?.update();
            }

        })
        
        let selectedIndex = -1;
        if(typeof this.selectedValues[depth] !== 'undefined'){
            const nowVal = Number(this.selectedValues[depth].value)

            selectedIndex = items.findIndex((v) => v.text === this.selectedValues[depth].text);
            items.forEach(function(){
                if (selectedIndex === -1 && nowVal > Number(items[items.length-1].value)) {
                    selectedIndex = items.length-1
                } else if (selectedIndex === -1 && nowVal < Number(items[0].value)) {
                    selectedIndex = 0;
                }
            })
        }

        // [FETASK-702] 자동이체주기 이전 값 유지
        if (this.defaults.item === 'cycle-date') {
            const filteredValue = ['매일', '매주', '신청안함'].some(v => v === this.activeSwiperValue);
            if(filteredValue){
                // activeSwiperValue가 '매월'이 아닌 경우 이전 과 index값 유지
                selectedIndex = this.cloneSelectedValues[depth] && items.findIndex((v) => v.text === this.cloneSelectedValues[depth].text);
                this.selectedValues = this.cloneSelectedValues.length && [...this.cloneSelectedValues];
            }
        }
        
        if(selectedIndex !== -1 && selectedIndex !== undefined){
            this.setSwiperSlideTo(depth, selectedIndex);
           
            return items[selectedIndex].text
        }else{
            this.setSwiperSlideTo(depth, selectedIndex);
            return items[0]?.text
        }    
    }

    // 각 피커의 위치를 지정
    // @param depth 피커 위치
    // @param selectedIndex 해당 인덱스
    setSwiperSlideTo(depth, selectedIndex){
        if(selectedIndex !== -1){
            this.swiperInstances[depth] && this.swiperInstances[depth].slideTo(selectedIndex, 0, false);
        }else{
            this.swiperInstances[depth] && this.swiperInstances[depth].slideTo(0, 0, false);
        }
        if (this.defaults.item != 'cycle-date' || this.defaults.cols == 'undefined') {
            if(this.defaults.item === 'cycle-date-tab') return;  // [CHPFMTASK-2128] TAB + DateSpinner 조합일 경우 2015.04.16
            const id = this.swiperIds[depth];
            this.$popup.find((`.${id}`)).each((idx,el)=>{
                const _swiper = $(el)[0].swiper;
                if (typeof this.selectedValues[depth] !== 'undefined') {
                    if (typeof this.selectedValues[depth].text !== 'undefined') {this.selectedValues[depth].text = this.arrData[depth][_swiper.activeIndex].text}
                    if (typeof this.selectedValues[depth].value !== 'undefined') {this.selectedValues[depth].value = this.arrData[depth][_swiper.activeIndex].value}
                }
            })
        }
    }

    /**
     * 피커에 값 삽입
     * @param depth 첫번째 두번째에 해당
     * @param value 값
     */
    setValue(depth, value){
        setTimeout(() => {
            if(this.arrData[depth] && this.arrData[depth].length > 0){
                const selectedIndex = this.arrData[depth].findIndex((obj) => value === obj.value)
                this.selectedValues[depth] = this.arrData[depth].find((obj) => value === obj.value)
                this.setSwiperSlideTo(depth, selectedIndex);
                // console.log('depth', depth)
                // console.log('value', value)
                // this.swiperInstances[depth].emit('slideChange')
                this.export();
            }
        });
    }

    setDisabed(depth, value){
        setTimeout(() => {
            if(this.arrData[depth] && this.arrData[depth].length > 0){
                const selectedIndex = this.arrData[depth].findIndex((obj) => value === obj.value)
                this.swiperInstances[depth].slides[selectedIndex].classList.add('disabled');
            }
        });
    }

    // PopupCalendar. js 에서 사용 
    // 캘린더 팝업에서 title,subtitle,spinner 값을  dateSpinner 의 값으로  가져올때 사용
    // opt.spinner, opt.title, opt.subTitle
    popupTitle(opt){
        const titleField = this.$popup.find('.title-field-popup');
        const guideField = this.$popup.find('.txt-guide-popup');
        /*! s: FETASK-a11y page DateSpinner 수정 v.1.0.0 */
        if(isA11yCheckVersion()){
            if(Popup.arrPopup?.[0] == undefined) {
                // 페이지 캘린더 + dateSpinner 일때
                csTitle(true);
            }else if(Popup.arrPopup?.[0].attr('data-type') === 'calendar'){
                //캘린더 + dateSpinner 일때
                csTitle(true);
            }else{
                //캘린더 + dateSpinner 아닐시 기존 소스 동작 로직
                csTitle();
            }
        }else{
            //기존 소스
            csTitle();
        }
        function csTitle(val){
            titleField?.text(opt.title);
            guideField?.text(opt.spinner);
            if (val && guideField.length>0) {
                guideField.addClass('title-mixed-calendar').attr({'role':'button', 'title':'선택'});
            } else if (val) {
                titleField.addClass('title-mixed-calendar').attr({'role':'button', 'title':'선택'});
            }
        }
        $(document).on(`click${this.eventId}`, '.title-mixed-calendar', (e)=>{
            // console.log(1212)
            this.$popup?.find('.ui-btnConfirm').trigger('click');
        })

        /*! s: FETASK-a11y page DateSpinner 수정 v.1.0.0 */

        // if (subtit != undefined) {
        //     this.$popup.find('.title-group').append(`<div class="txt-guide-popup caln-sub-txt">${subtit}</div>`)
        // }
    }

    /**
     * 전달된 값으로 스피너 위치 이동
     * @param values 배열 ['매주', '수']
     */
    setSlideTo(values){
        this.selectedValues = [];
        values.length && values.forEach((value, index) => {
            this.setValue(index, value);
        });
        setTimeout(() => this.cloneSelectedValues = [...this.selectedValues]);
    }

    setSelectedData(...args){
        const arr = [];
        args.forEach((arg) => {
            arr.push({text: arg, value: arg});
        });
        return arr;
    }

    saveSelectedData(selectedData){
        if(this.savedDataList.current && this.savedDataList.current.length){
            this.savedDataList.prev = [...this.savedDataList.current];
        }
        this.savedDataList.current = selectedData.map(data => data.value);
    }

    getToday(depth){
        const newList = [];
        newList.push(depth);
        if(depth === '매주'){
            const week = ['월', '화', '수', '목', '금', '토', '일'];
            const today = new Date().getDay() > 0 ? new Date().getDay() - 1 : 6;
            newList.push(week[today]);
        }
        return newList;
    }

    /**
    * 실질적인 초기화에 가깝다. 값을 넣어주고 체인지 이벤트를 받고 선택 완료시 콜백을 실행시킨다.
    * @param initFn    {function}  초기화 콜백
    * @param slideChangeFn    {function}  change event 콜백
    * @param exportFn    {function}  선택 완료시 콜백
    * @example
    * function getDataDepth1() {
    *    return [{
    *        text: '서울특별시',
    *        value: '서울특별시'
    *    },
    *    {
    *        text: '경기도',
    *        value: '경기도'
    *    },
    *    ]
    * }
    *  $('.ui-input').data('ui').setCallback({
    *    initFn: function() {
    *    var that = this;
    *    that.selectedValues = [$('.ui-input').find('.ui-text-del').val()];
    *    var list = getDataDepth1();
    *    $('.ui-input').data('ui').fillCustomData(0, list);
    *    that.swiperInstances[0].emit('slideChange')
    *    },
    *    slideChangeFn: function(depth, selectedIndex, data, swiper, selectedValues) {
    *    var that = this;
    *    //console.log(depth, selectedIndex, data, swiper, selectedValues)
    *    },
    *    exportFn: function(values) {
    *    //console.log(values);
    *    $('.ui-input').find('.ui-text-del').val(values[0].text)
    *    }
    *  })
     */
    setCallback({initFn, slideChangeFn, exportFn}){
        this.initFn = initFn;
        this.slideChangeFn = slideChangeFn;
        this.exportFn = exportFn;
        this.render();
    }
    depth4DataSetting(chk) {
        let setData = []
        const _hours = new Date().getHours();
        if (_hours > 15) {chk = true}
        if (chk == true) {
            setData = ['08~09시', '11~12시', '15~16시']
        } else {
            if (_hours >= 12 && _hours <= 15) {
                setData = ['15~16시'];
            } else if (_hours >= 9 && _hours < 12) {
                setData = ['11~12시', '15~16시'];
            } else if (_hours <= 8){
                setData = ['08~09시','11~12시', '15~16시'];
            }
        }
        return setData
    }
    
    /**
     * ui-input 클래스 태그에 done 클래스가 완료된 시점의 콜백
     * @param callback {function} 
     * @example 
     *  $('.ui-input').data('ui').setValues(function(){});
     */
    setDone(callback){
        !!this.$el.find('input').val() && this.$el.addClass('done');

        if (callback && $.isFunction(callback)) {
            this.setDoneCallback = callback;
        }
    }

    // 한자릿수 숫자를 두자리 문자로 만들어준다.
    // @param v {number}    수
    // @returns {string}    ex) 9 => 09
    static getFormatZero(v){
        return getFormatZero(v);
    }

     // 년을 가져온다.
     // @param min   최소
     // @param max   최대
     // @param pass  제외할 년
     // @example
     //  DateSpinner.getYear(2015, 2020, [2017]);
     //  // [2015, 2016, 2018, 2019, 2020]
     // @returns {*}
    static getYear(min = 1970, max = new Date().getFullYear(), pass = []){
        const date = new Date();

        const arr = new Array(max - min + 1).fill(0);

        return arr.map((value, index) => min + index).filter((value) => !pass.some((v) => v === value)).map((v) => ({text: v+'년', value: v}))
    }

    // 월을 가져온다.
    // @param year  년
    // @param min   최소
    // @param max   최대
    // @param pass  제외할 달
    // @example
    //  DateSpinner.getMonth(3, 7, [4]);
    //  // [3, 5, 6, 7]
    // @returns {*}
    static getMonth(year = new Date().getFullYear(), min = 1, max = 12, pass = []){
        const date = new Date();

        
        date.setFullYear(year);
        const arr = new Array(max - min + 1).fill(0);

        return arr.map((value, index) => min + index).filter((value) => !pass.some((v) => v === value)).map((v) => ({text: v+'월', value: v}))
    }

    // 날을 가져온다.
    // @param year  연
    // @param month 월
    // @param min   최소
    // @param max   최대
    // @param pass  제외할 날
    // @example
    //  DateSpinner.getDate(5, 10);
    //  // [5, 6, 7, 8, 9, 10]
    // @returns {*}
    static getDate(year = new Date().getFullYear(), month = new Date().getMonth() + 1, min = 1, max = 31, pass = []){
        const date = new Date(year, month, 0);

        //date.setFullYear(year);
        //date.setMonth(month);
        //date.setDate(0);
        //////console.log(year,month,min,max)
        // let setDateArr = [31,28,31,30,31,30,31,31,30,31,30,31];
        // if (year % 4  == 0 && year % 100 != 0 || year % 400 ==0) {
        //     setDateArr[1] = 29
        // } else {
        //     setDateArr[1] = 28
        // };
        // if (max == undefined || max == 31) {
        //     max = setDateArr[month-1]
        // }
        if(max === 31){
            max = date.getDate()
        }

        const arr = new Array(max - min + 1).fill(0);
        return arr.map((value, index) => min + index).filter((value) => !pass.some((v) => v === value)).map((v) => ({text: v+'일', value: v}))
    }

    // 시간을 가져온다.
    // @param min   최소시간
    // @param max   최대시간
    // @param pass  제외할 시간
    // @example
    //  DateSpinner.getHour(2, 10, [5, 6])
    //  // [2, 3, 4, 7, 8, 9, 10]
    // @returns {*}
    static getHour(min = 0, max = 23, pass = []){
        const arr = new Array(max - min + 1).fill(0);

        return arr.map((value, index) => min + index).filter((value) => !pass.some((v) => v === value)).map((v) => ({text: v+'시', value: v}))
    }

    /**
     * 확인필요
     * @param {Array} value  선택된 값 배열형태
     * @example
     * $('.ui-input').data('ui').setSelectedValues([{text: "오후", value: "오후"}, {text: "1시", value: "1시"}]);
     */
    setSelectedValues(value){
        this.selectedValues = value;

        this.selectedValues.forEach((value, depth) => {
            // console.log('arrData',this.arrData[depth])
            const index = this.arrData[depth].findIndex((v) => v.text === this.selectedValues[depth].text || v.text === this.selectedValues[depth])
            this.swiperInstances[depth] && this.swiperInstances[depth].slideTo(index, 0, false);
        })
    }

    /**
     * 피커에 값 삽입
     * @param {Array<string|number>} values 넣어줄 value
     * @param {string} spinnerType 넣어줄 value
     * @example 
     * $('.ui-input').data('ui').setValues([2020, 1, 1]);
     * $('.ui-input').data('ui').setValues([2020, 1, 1], 'couponType');
     */
     setValues(values, spinnerType){ //CHPFMTASK-2098
        var that = this;
        if (this.arrData.length <= 0) {
            this.render();
            this.$el.addClass('done');
        }

        const checkIf = spinnerType === "couponType" && this.$el.attr('data-date') === 'YYMMDD'; //CHPFMTASK-2098
        let arrDepth = []; //CHPFMTASK-2098

        setTimeout(() => {
            //CHPFMTASK-2098
            if(checkIf){
                const fromDate = new Date('2010-01-01');
                const toDate = new Date('2026-12-31');
                this.setDateSet(fromDate,toDate);
            }

            values.forEach((value, depth) => {
                if(this.arrData[depth] && this.arrData[depth].length > 0){
                    const selectedIndex = this.arrData[depth].findIndex((obj) => value === obj.value)
                    this.selectedValues[depth] = this.arrData[depth].find((obj) => value === obj.value)
                    
                    checkIf ? arrDepth.push(selectedIndex) : (console.log('setSwiperSlideTo init'), this.setSwiperSlideTo(depth, selectedIndex)); //CHPFMTASK-2098
                }
            });

            if(this.swiperInstances.length>0){
                checkIf ? this.export(arrDepth) : this.export(); //CHPFMTASK-2098
                this.setDone();
            }
        }, 0);
    }

    // 값 선택 후 바닥페이지에 값을 넣어줄때 사용한다.
    // export(){
    //     const selectedData = this.swiperInstances.map((swiper, depth) => {
    //         return this.arrData[depth][swiper.activeIndex];
    //     });

    //     if(this.exportFn && $.isFunction(this.exportFn)){
    //         this.exportFn.call(this, selectedData)
    //     }else{
    //         this.$el.find('.txt-name').text(selectedData[0].text +' '+ selectedData[1].text)
    //     }
    // }

    export(value){ //CHPFMTASK-2098
        const swiperInstances = this.swiperInstances; //CHPFMTASK-2098
        const selectedData = swiperInstances.map((swiper, depth) => {
            return this.arrData[depth][value ? value[depth] : swiper.activeIndex]; //CHPFMTASK-2098
        });

        //CHPFMTASK-2098
        if(value){
            swiperInstances?.map((swiper, depth) => {
                // console.log('depth = ', depth +' / ' + 'value = ', value[depth]);
                // console.log('swiperInstances[depth].slides.length = ', swiperInstances[depth].slides.length);
                swiperInstances[depth].update();
                swiperInstances[depth].slideTo(value[depth], 0, false);
            });
        }
        
        if(this.exportFn && $.isFunction(this.exportFn)){
            this.exportFn.call(this, selectedData);
        }else{
            this.$el.find('.txt-name').text(selectedData[0].text +' '+ selectedData[1].text)
        }
    }

    // 날짜 데이터 생성
    // @param fromDate  시작일
    // @param toDate    종료일
    // @param customData    커스텀데이터
    setDateSet(fromDate, toDate, customData = []){
        // this.dateDataType = ['YY', 'MM', 'DD']; 이런형태로 연월일인지 연월인지 체크하여 값을 리턴해준다.
        this.dateDataType.forEach((dateType, depth) => {
            if(depth === 0 && dateType === 'DD'){
                // day only
                const year = fromDate.getFullYear();
                const month = fromDate.getMonth()+1;
                this.arrData[depth] = this.getDateArray(fromDate, toDate, year, month);
                // 말일 추가
                if (this.defaults.cycleLatest == true) {
                    this.arrData[depth].push({text: "말일", value: "32일"});
                }                
            }else{
                if(depth === 0){
                    // 년
                    this.arrData[depth] = this.getDateArray(fromDate, toDate);
                }else if(depth === 1){
                    // 월
                    const year = this.selectedValues[0].value;
                    this.arrData[depth] = this.getDateArray(fromDate, toDate, year);
                }else if(depth === 2){
                    // 일
                    const year = this.selectedValues[0].value;
                    const month = this.selectedValues[1].value;
                    this.arrData[depth] = this.getDateArray(fromDate, toDate, year, month);
                }else if(depth === 3){
                    this.arrData[depth] = customData;
                }
            }
            this.selectedValues[depth] = this.selectedValues[depth] || this.arrData[depth][0];

            this.fillCustomData(depth, this.arrData[depth], this.selectedValues[depth]);
        })
    }

    // 시작일 종료일을 넣고 연월일을 넣으면 해당 배열을 리턴한다.
    // @param fromDate  시작일
    // @param toDate    종료일
    // @param year  년
    // @param month 월
    // @param date  일
    // @returns {*}
    getDateArray(fromDate, toDate, year, month, date){
        const from = new Date(fromDate);
        const fromYear = from.getFullYear();
        const fromMonth = from.getMonth()+1;
        const fromDateDate = from.getDate();
        const fromHour = from.getHours();

        const to = new Date(toDate);
        const toYear = to.getFullYear();
        const toMonth = to.getMonth()+1;
        const toDateDate = to.getDate();
        const toHour = to.getHours();

        if(typeof year === 'undefined'
            && typeof month === 'undefined'
            && typeof date === 'undefined'){
                return DateSpinner.getYear(fromYear, toYear);
        }else if(typeof month === 'undefined'
            && typeof date === 'undefined'){
            if(fromYear === toYear){
                return DateSpinner.getMonth(year, fromMonth, toMonth);
            }else if(fromYear === year){
                return DateSpinner.getMonth(year, fromMonth, 12);
            }else if(toYear === year){
                return DateSpinner.getMonth(year, 1, toMonth);
            }else{
                return DateSpinner.getMonth(year);
            }
        }else if(typeof date === 'undefined'){
            if(fromYear === year && fromMonth === month){
                if(toYear === year && toMonth === month){
                    if(fromDateDate === toDateDate){
                        return DateSpinner.getDate(year, month, 1, 31);
                    }else{
                        return DateSpinner.getDate(year, month, fromDateDate, toDateDate);
                    }
                }else{
                    return DateSpinner.getDate(year, month, fromDateDate, 31);
                }
            } else if (fromYear === year && fromMonth > month) {
                return DateSpinner.getDate(year, fromMonth, fromDateDate, 31);
                // return DateSpinner.getDate(year, month, fromDateDate, 31);
            } else if(toYear === year && toMonth === month){
                return DateSpinner.getDate(year, month, 1, toDateDate);
            } else if (toYear === year && toMonth < month) {
                return DateSpinner.getDate(year, toMonth, 1, toDateDate);
            }else {
                return DateSpinner.getDate(year, month);
            }
        }else{
            if(fromYear === year && fromMonth === month && fromDateDate === date){
                return DateSpinner.getHour(fromHour, 23);
            }else if(toYear === year && toMonth === month && toDateDate === date){
                return DateSpinner.getHour(1, toHour);
            }else {
                return DateSpinner.getHour();
            }
        }
    }

    openMotion(cancelMotion) {
        //console.log('s.selectedValues',this.selectedValues )
        if (this.$el.attr('selected-check') == 'false' && this.defaults.item == 'ampm-date') {
            this.selectedValues = []
        }
        if (!this.selectedValues.length > 0 && this.defaults.item == 'ampm-date') { // 231123 selected-check   관련 추가
            this.$el.attr('selected-check', false)
        }
        // [FETASK-702] 이전 상태값으로 유지
        if(this.defaults.item === 'cycle-date'){
            this.setStatusBackAction();
        }
        if(this.defaults.item == 'ampm-date'){
            if (!this.selectedValues.length > 0) {
                this.$popup.find('.popup-footer .btn-group').attr('button-num',1)
                this.$popup.find('.popup-footer .divider-gray').css('display','none');
            } else {
                this.$popup.find('.popup-footer .btn-group').attr('button-num',2)
                this.$popup.find('.popup-footer .divider-gray').css('display','inline-flex')
            }
        }
        
        //TODO 2024.05.23 배포 주석
        //비정형 group-spinner 일때만 버튼 this.swiperInstances로 버튼생성
        if(this.$popup?.find('.group-spinner')?.length){
            setTimeout(() => {
                isA11yGroupSpinnerUpdate(this.swiperInstances, this.$popup);
            }, 500);
            
        }
        
        this.openCallbackAction();
        
        let callbackFunc;
        //[FETASK-822] 콜백 함수 추가
        this.openCommonMotion({
            cancelMotion,
            callback: () => {
                if (typeof callbackFunc == 'function') callbackFunc();
            }
        });

        return {
            callback: function(c){callbackFunc = c;}
        }        
    }

    closeMotion(cancelMotion) {
        let callbackFunc;
        //[FETASK-822] 콜백 함수 추가
        this.closeCommonMotion({
            cancelMotion,
            callback: () => {
                if (typeof callbackFunc == 'function') callbackFunc();
            }
        });

        return {
            callback: function(c){callbackFunc = c}
        }
    }

    /**
     * dateSpinner open 이벤트
     * @param callback {function} | 실행 즉시 실행 콜백 (콜백 이후 데이트스피너 반팝업 오픈 모션)
     * @example 
     *  $('.ui-input').data('ui').open(function(){});
     */
    open(fn = () => {
    }) {
        fn();
        // setTimeout(() => {
        if(!this.$popup){
            this.render();
        }
            this.openMotion();
        // }, 0);defaults
    }
    /**
     * dateSpinner close 이벤트
     * @param callback {function} | 실행 즉시 실행 콜백 (콜백 이후 데이트스피너 반팝업 오픈 모션)
     * @example 
     *  $('.ui-input').data('ui').close(function(){});
     */
    close(fn = () => {
    }) {
        fn();

        this.closeMotion();
    }
    /**
     * dateSpinner 반팝업 확인기능(우측) 버튼 콜백
     * * 현재 사용하는곳 data-item="ampm-date"
     * @param callback {function}
     * @example 
     *  $('.ui-input').data('ui').posiBtnCallback(function(){});
     */
    posiBtnCallback(callback) {
        this.posiCallback = callback;
    }
    posiBtnCallbackAtction() {
        if (this.posiCallback && $.isFunction(this.posiCallback)) {
            this.posiCallback();
        } 
    }
    /**
     * dateSpinner 반팝업 취소기능(좌측) 버튼 콜백
     * * 현재 사용하는곳 data-item="ampm-date"
     * @param callback {function}
     * @example 
     *  $('.ui-input').data('ui').posiBtnCallback(function(){});
     */
    negaBtnCallback(callback) {
        this.negaCallback = callback;
    }
    negaBtnCallbackAtction() {
        if (this.negaCallback && $.isFunction(this.negaCallback)) {
            this.negaCallback();
        } 
    }
    /**
     * data-item="ampm-date" 에서만사용 | 오전오후 타입 전용 콜백
     * @param callback {function}
     * @example 
     *  $('.ui-input').data('ui').beforeOpenCallback(function(){});
     */
    beforeOpenCallback(callback) {
        this.openCallback = callback;
    }
    
    openCallbackAction() {
        if (this.openCallback && $.isFunction(this.openCallback)) {
            this.openCallback();
        } 
    }
    /**
     * 데이트스피너 팝업 닫히는 시점의 콜백 
     * @param callback {function}
     * @example 
     *  $('.ui-input').data('ui').beforeCloseCallback(function(){});
     */
    beforeCloseCallback(callback) {
        this.closeCallback = callback;
    }

    closeCheckPageCalendar(){
        // 페이지 달력이 있으면 닫을때 실행
        if($('.ui-calendar').data('ui') != undefined && $('.ui-calendar').data('ui').$el.attr('page-calendar') != undefined){
            $('.ui-calendar').data('ui').calendarGetDateShow();
            $('.ui-calendar').data('ui').calendarClickScroll();
        }
    }
    /**
     * 데이트스피너 팝업이 닫히기 
     * @param callback {function}
     * @example 
     *  $('.ui-input').data('ui').beforeOpenCallback(function(){});
     */
    closeCallbackAction() {
        if (this.closeCallback && $.isFunction(this.closeCallback)) {
            this.closeCallback();
            // this.closeCheckPageCalendar();
        } else {
            this.closeMotion().callback(() => {
                //[FETASK-822] swiper의 activeIndex 설정을 위한 callback 추가
                // 스피너 팝업 아닐때
                if (this.defaults.area) {
                    this.$el.closest('.ui-popup').data('ui').setSwiperSlideTo();
                }else{
                    if (this.defaults.item !== 'cycle-date' || this.defaults.item !== 'ampm-date') {  // FETASK-1555 ampm-date 값 추가
                        this.$popup.data('ui').setSwiperSlideTo();
                    }
                }

                // this.closeCheckPageCalendar();
                
                /*! s: FETASK-a11y page DateSpinner 옵션 수정 v.1.0.0 */
                //input dateSpinner접근성 로직 추가
                const isA11yCheck = isA11yCheckVersion();

                if(isA11yCheck){
                    const dimm = this.$popup[0].parentElement.querySelector('.dimm');

                    if(dimm){
                        //중복 팝업일시 dim z-index제대로 적용안되는 이슈 수정
                        if(Popup?.arrPrePopup[0]){
                            dimm.style.zIndex = Number(Popup.arrPrePopup[0]?.css('zIndex')) - 1;
                        }
                    }
                    
                    Popup.a11yDetctClosePopup();
                    
                    setTimeout(async () => {
                        const uiWidget = document.querySelector('.ui-widget');
                        const activeItem = document.querySelector('.activeSlide');
                        const popupEles = document.querySelectorAll('.ui-popup');
                        const activePopupEle = document.querySelector('.activePopup') //activePopup

                        const scrollInnerEles = document.querySelectorAll('.page-inner-scroll');

                        document.querySelector('body').style = '';
                        isA11ySetAttr(scrollInnerEles, 'style', '');

                        const formBoxEles = document.querySelectorAll('.ui-formBox[tabindex], .ui-input.readonly[tabindex]');

                        this.$popup[0].classList.remove('activePopup');

                        if(Popup.arrPrePopup.length){
                            //dateSpinner 닫힐때 캘린더형태 버튼영역 막히는거 수정
                            this.isA11yCloseAfterCalendar();
                        }
                        
                        
                        const dateSpinnerEles = document.querySelectorAll('[data-mapping-toggle="directBox"] input[type="text"]');
                        isA11ySetAttr(dateSpinnerEles, 'aria-hidden', 'false');

                        const toggleRadioLink = document.querySelectorAll('.ui-ToggleRadio .toggle-item input[type="radio"], .ui-ToggleRadio .toggle-item a');
                
                        isA11ySetAttr(toggleRadioLink, 'aria-hidden', 'true');

                        const calnEventBtn = document?.querySelector('.jui-datepicker-title');
                        calnEventBtn?.setAttribute('tabindex','0');

                        this.isA11ySpinnerLive('remove');

                        //dateSpinner data-type="dateSpinner" 접근성
                        const inputParentPrevent = document?.querySelectorAll('.ui-input[data-type="dateSpinner"]');
                        const inputPrevent = document?.querySelectorAll('.ui-input[data-type="dateSpinner"] input');

                        isA11ySetAttr(inputParentPrevent,'aria-hidden', 'false');
                        isA11ySetAttr(inputPrevent,'aria-hidden', 'true');

                        this.isA11ySelectTypeAcess();
                    }, 500);
                }
                /*! e: FETASK-a11y page DateSpinner 옵션 수정 v.1.0.0 */
            });
        }
    }

    attachEvents() {
        // 버튼과 인풋일 경우 이벤트가 달린다.
        const _that = this;
        if(this.isHiddenInput){
            this.$el.find('button').on(`click${this.eventId}`, (e) => {
                e.preventDefault();
                const focusEl = document.activeElement;
                focusEl.nodeName === 'INPUT' && focusEl.blur(); // focus된 input이 있는 경우 blur처리
         
                if(!this.$popup){
                    this.render();
                }
                this.openMotion().callback(() => {
                    //[FETASK-822] swiper의 activeIndex 설정을 위한 callback 추가
                    // 스피너 팝업 아닐때
                    if (this.defaults.area) {
                        this.$el.closest('.ui-popup').data('ui').saveSwiperActiveIdx.call(this).callback(() => {
                            this.$el.closest('.ui-popup').data('ui').setSwiperSlideTo();
                        });
                    }else{
                        if (this.defaults.item !== 'cycle-date') {
                            this.$popup.data('ui').saveSwiperActiveIdx.call(this).callback(() => {
                                this.$popup.data('ui').setSwiperSlideTo();
                            });
                        }
                    }
                });
            });
        }else{
            this.$el.find('input').on(`click${this.eventId}`, (e) => {
                e.preventDefault();
                
                if(isA11yCheckVersion()){
                    //readonly, disabled 일때 이벤트 막기
                    const isCheckDisabledEvent = (e.target?.attributes['disabled']) && !this.$el.prev('.ui-datepicker.hasDatepicker')?.length; //캘린더 + dateSpinner this.$el readonly경우 제외

                    if(isCheckDisabledEvent) return;
                }

                const focusEl = document.activeElement;
                focusEl.nodeName === 'INPUT' && focusEl.blur(); // focus된 input이 있는 경우 blur처리

                if(!this.$popup){
                    this.render();
                }

                this.cycleDateTabAction('update'); // [CHPFMTASK-2128] TAB + DateSpinner 조합일 경우 2015.04.16

                this.openMotion().callback(() => {
                    //[FETASK-822] swiper의 activeIndex 설정을 위한 callback 추가
                    // 스피너 팝업 아닐때
                    if (this.defaults.area) {
                        this.$el.closest('.ui-popup').data('ui').saveSwiperActiveIdx.call(this).callback(() => {
                            this.$el.closest('.ui-popup').data('ui').setSwiperSlideTo();
                        });    
                    }else{
                        if (this.defaults.item !== 'cycle-date') {   
                            this.$popup.data('ui').saveSwiperActiveIdx.call(this).callback(() => {
                                this.$popup.data('ui').setSwiperSlideTo();
                            });    
                        }
                        this.cycleDateTabAction('event'); // [CHPFMTASK-2128] TAB + DateSpinner 조합일 경우 2015.04.16
                    }

                    /*! s: FETASK-a11y page DateSpinner 수정 v.1.0.0 */
                    const isA11yCheck = isA11yCheckVersion();

                    if(isA11yCheck && this.defaults.type === 'dateSpinner'){
                        setTimeout(async ()=>{
                            //TODO - active된 dateSpinner 팝업 div로직 필요
                            const activeSlides = document.querySelector('.activeSlide');
                            const popupEles = document.querySelectorAll('.ui-popup'); //모든팝업 선택

                            const formBoxEles = document.querySelectorAll('.ui-formBox[tabindex], .ui-input.readonly[tabindex]');

                            formBoxEles && isA11ySetAttr(formBoxEles,'aria-hidden','true');
                            
                            this.isA11ySwipeList();

                            //스피너 라이브 영역 1개만 남기기
                            isA11yOnceSpinnerDiv();
                        },500);
                    }
                    /*! e: FETASK-a11y page DateSpinner 수정 v.1.0.0 */
                });
            });
        }
        if (this.$el.find('[data-role="valReset"]').length > 0) { //이체하기 예약일시설정 초기화 버튼
            this.$el.find('[data-role="valReset"]').off(`click${this.eventId}`).on(`click${this.eventId}`, function(e){
                const inputWrap = $(e.currentTarget).closest('.ui-input');
                inputWrap.removeClass('done');
                inputWrap.find('.ui-text-del').val('');
            })
        }

        /*! s: FETASK-a11y page DateSpinner 수정 v.1.0.0 */
        if(this.defaults.cycleLatest && isA11yCheckVersion()){
            this.isA11ySwipeList();

            //스피너 라이브 영역 1개만 남기기
            isA11yOnceSpinnerDiv();
        }
        /*! e: FETASK-a11y page DateSpinner 수정 v.1.0.0 */
    }

    detachEvents() {
        this.$el.find('input').off(this.eventId);
        this.$el.find('input').next('button').off(this.eventId);
        
        if (this.$el.find('[data-role="valReset"]').length > 0) { //이체하기 예약일시설정 초기화 버튼
            this.$el.find('[data-role="valReset"]').off(`click${this.eventId}`)
        }
    }

    setStatusBackAction() {
        if(this.savedDataList.current && this.savedDataList.current.length){
            const currentData = this.savedDataList.current;
            this.setSlideTo(currentData);
        }
    }

    attachPopupEvents() {
        this.$popup.on(`click${this.eventId}`, (e) => {
            if (e.target === e.currentTarget) {
                //[FETASK-702] 이전 상태값으로 유지
                if(this.defaults.item === 'cycle-date'){
                    this.setStatusBackAction();
                }

                this.closeCallbackAction();
            }
        });

        this.$popup.on(`click${this.eventId}`, '.btn-popup-close', (e) => {
            e.preventDefault();

            this.closeCallbackAction();
        });

        this.$dimm.on(`click${this.eventId}`, (e) => {
            e.preventDefault();
            this.closeCallbackAction();
        });

        this.$popup.on(`scroll${this.eventId}`, (e) => {
            if (this.$popup[0].scrollTop === 0) {
                this.$popup.find('.btn-popup-close').removeClass('scroll');
            } else {
                this.$popup.find('.btn-popup-close').addClass('scroll');
            }
        });

        this.$popup.on(`click${this.eventId}`, '.ui-btnConfirm', (e) => {
            if (this.$el[0].hasAttribute('data-custom')) {
                const selectedData = this.swiperInstances.map((swiper) => {
                    return $(swiper.slides[swiper.activeIndex]).data('data');
                })

                if(this.exportFn && $.isFunction(this.exportFn)){
                    this.exportFn.call(this, selectedData)
                }else{
                    this.$el.find('.txt-name').text(selectedData[0].text +' '+ selectedData[1].text)
                }

            }else{
                
                const selectedData = this.swiperInstances.map((swiper) => {
                    const swiperData = $(swiper.slides[swiper.activeIndex]).data('data') ?? {text:'', value:''};
                    return swiperData;
                })

                if(this.exportFn && $.isFunction(this.exportFn)){
                    this.exportFn.call(this, selectedData)
                }else{
                    let formatZeroDate
                    if(this.$el.filter('[data-date=YYMMDDH1]').length > 0){
                        formatZeroDate = selectedData.splice(0, 3).map((v) => getFormatZero(v)).join('.')
                        //formatZeroDate = selectedData.splice(0, 3).map((v) => v).join('.')
                        formatZeroDate += ' ' + selectedData;
                    }else{
                        formatZeroDate = selectedData.map((v) => getFormatZero(v)).join('.')
                        //formatZeroDate = selectedData.map((v) => v).join('.')
                    }
                   

                    if (this.defaults.item !== 'cycle-date' && this.defaults.cycleLatest !== true) {
                        this.$el.find('.ui-text-del').val(formatZeroDate)
                    }
                }

                if (this.defaults.item === 'cycle-date') {
                    this.activeSwiperValue = this.defaultLists[0] === '매월' && selectedData[0].text;
                    this.selectedValues = [...selectedData];
                    this.cloneSelectedValues = [...selectedData];
                    this.saveSelectedData(selectedData); 
                }
            }
            if (this.$el.attr('selected-check') != undefined && this.defaults.item == 'ampm-date') {
                this.$el.attr('selected-check', true)
            }
            if (this.setDoneCallback && $.isFunction(this.setDoneCallback)) {
                this.setDoneCallback();
            }

            this.setDone();
            if (this.posiCallback) { // 확인(우측버튼) 클릭시 콜백 closecallback 이랑 다른개념
                this.posiBtnCallbackAtction()
            }else {
                this.closeCallbackAction();
            }

            if (this.$el.closest('[spinnertype]').length > 0) {  // 데이터피커 테스트
                this.$el.closest('[spinnertype]').find('.jui-datepicker-year').val(this.selectedValues[0].text.replace('년','')).trigger('change')
                this.$el.closest('[spinnertype]').find('.jui-datepicker-month').val(Number(this.selectedValues[1].text.replace('월',''))-1).trigger('change')
            }

            /*! s: FETASK-a11y page dateSpinner 예약버튼 로직 v.1.0.0 */
            if(isA11yCheckVersion() && this.$el.find('[data-role="valReset"]')){
                this.closeReservationBtnChange(this.$el[0]);
                this.$el.find('[data-role="valReset"]').remove();
            }

            if(isA11yCheckVersion()){
                this.$popup?.find('.close-btn').trigger('click');
            }
            /*! e: FETASK-a11y page dateSpinner 예약버튼 로직 v.1.0.0 */
        });

        this.$popup.on(`click${this.eventId}`, '.ui-btnCancel', (e) => {
            if (this.defaults.item == 'ampm-date') { // FETASK-1555 | 오전 오후에서만 우선 사용
                this.$el.find('input').attr('value', '');
                this.$el.find('input').val('');
                this.selectedValues = [];
                // if (this.$el.find('.ampm-text').length > 0){ // 240313 : 개발요청 제거 개발에서 컨트롤
                //     this.$el.find('.ampm-text').text('')
                // }
                
                this.$el.removeClass('done');
                if (this.setDoneCallback && $.isFunction(this.setDoneCallback)) {
                    this.setDoneCallback();
                }
                if (this.negaCallback) {
                    this.negaBtnCallbackAtction()
                } else {
                    this.closeCallbackAction();
                }
                
            }
            
        });
        this.$el.on(`click${this.eventId}`, '.ico-delete-input', (e) => {
            this.$el.find('input').val('');
            this.$el.removeClass('done');
        });
        /*! s: FETASK-a11y page DateSpinner 수정 v.1.0.0 */
        // if(this.$popup?.find('.popup-header .title-mixed-calendar')?.length && isA11yCheckVersion()){
        //     this.$popup?.find('.popup-header .title-mixed-calendar').on(`click${this.eventId}`, (_) => {
        //         this.$popup?.find('.ui-btnConfirm').trigger('click');
        //     });
        // }
        /*! s: FETASK-a11y page DateSpinner 수정 v.1.0.0 */


    }

    /**
     * submit버튼을 비활성화한다.
     * @param   {Boolean} bool 비활성화여부
     * @example
     * $('.ui-input').data('ui').setDisableSubmit(true);
     */
    setDisableSubmit(bool){
        if(!this.$popup){
            return;
        }
        if(bool){
            this.$popup.find('.ui-btnConfirm').prop('disabled', true);
        }else{
            this.$popup.find('.ui-btnConfirm').prop('disabled', false);
        }
    }

    // 해당 인덱스 하위 배열을 날린다.
    // @param arr   배열
    // @param index 하위로 날릴 배열인덱스
    // @returns {*}
    static removeArrayTail(arr, index){
        return arr.map((v, i) => i<index ? v: undefined);
    }

    detachPopupEvents() {
        this.$popup && this.$popup.off(this.eventId);

        this.swiperInstances.map((swiper, index) => {
            swiper.destroy();
        })
    }

    destroy() {
        this.detachEvents();
        this.detachPopupEvents();

        this.swiperInstances.map((swiper, index) => {
            swiper.destroy();
        })
    }

    /*! s: FETASK-a11y page v.1.0.0 */
    isA11yDateSpinnerKeyEvent(){
        try {
            //input dateSpinner접근성 로직 추가
            const dateSpinnerInputs = document?.querySelectorAll('.input-txt-group[data-type="dateSpinner"]:not(.disabled), .input-close-group[data-type="dateSpinner"]:not(.disabled), .input-line-group[data-type="dateSpinner"]:not(.disabled), .input-triangle-group[data-type="dateSpinner"]:not(.disabled), .input-arrow-group[data-type="dateSpinner"]:not(.disabled), .btn-group[data-type="dateSpinner"]:not(.disabled), .selectbox-bl-radius-group[data-type="dateSpinner"]:not(.disabled),.input-close-group[data-type="dateSpinner"]:not(.disabled)');

            dateSpinnerInputs?.forEach((list) => {
                const labelEle = list.querySelector('label');

                list.setAttribute('tabindex','0');
                list.setAttribute('aria-hidden','false');
                
                //안드로이드 스크린리더 클릭
                list?.addEventListener('click', (_) => {
                    //if($(list).find('input').attr('readonly')) return;

                    $(list).find('input, button').trigger('click');
                    $(list).focus();
                });
                
                if(labelEle){
                    setTimeout(() => {
                        labelEle.setAttribute('aria-hidden','true');
                    },500);
                }
            });
        } catch (error) {
            throw new Error(`func isA11yDateSpinnerKeyEvent ${error}`);
        }
    }

    isA11ySwipeList(){
        try {
            const preventFocusListEle = this.$popup[0].querySelectorAll('.swiper-wrapper li');
            const preventFocusList = this.$popup[0].querySelectorAll('.swiper-wrapper li > button');
            
            //스와이프 tabindex 모두 막기
            isA11ySetAttr(preventFocusListEle,'tabindex', '-1');
            isA11ySetAttr(preventFocusListEle,'aria-hidden', 'true');
            isA11ySetAttr(preventFocusList,'tabindex', '-1');
            isA11ySetAttr(preventFocusList,'aria-hidden', 'true');
        } catch (error) {
            throw new Error(`func isA11ySwipeList ${error}`);
        }
    }

    isA11ySwipePrevNextButton(sw){
        if(!sw) return;

        try {
            const swipe = sw;
                                        
            const { previousIndex , activeIndex, $wrapperEl, $el, slides } = swipe;
            const depth = $($el).index();
            const buttonBox = $wrapperEl[0]?.parentElement;
            const buttons = buttonBox?.querySelectorAll('.control-btn');
            const maxLength = $wrapperEl[0]?.children?.length;

            const minValue = this.arrData[depth][0];
            const maxValue = this.arrData[depth][slides?.length - 1 ?? 0];
            const valueNow = this.arrData[depth][activeIndex];

            if(activeIndex < previousIndex){
                //이전
                buttons[0]?.setAttribute('aria-valuemin', `${minValue?.value}`);
                buttons[0]?.setAttribute('aria-valuemax', `${maxValue?.value}`);
            }else{
                //다음
                buttons[1]?.setAttribute('aria-valuemin', `${minValue?.value}`);
                buttons[1]?.setAttribute('aria-valuemax', `${maxValue?.value}`);
            }
            
            buttons[0]?.setAttribute('aria-valuetext', `${valueNow?.text}`);
            buttons[1]?.setAttribute('aria-valuetext', `${valueNow?.text}`);

            buttons[0]?.setAttribute('aria-valuenow', `${valueNow?.text}`);
            buttons[1]?.setAttribute('aria-valuenow', `${valueNow?.text}`);

            this.initSwipeBtns(activeIndex);
        } catch (error) {
            throw new Error(`func isA11ySwipePrevNextButton ${error}`);
        }
    }

    isA11yAddCloseBtn(){
        try {
            //팝업 닫기버튼 추가
        } catch (error) {
            throw new Error(`func isA11yAddCloseBtn ${error}`);
        }
    }

    isA11yAddInputArea(sw, type='init'){
        try {
            const {slides, activeIndex, $el, $wrapperEl} = sw;
        
            slides.forEach((item)=> item.setAttribute('aria-selected', 'false'));
            slides[activeIndex]?.setAttribute('aria-selected', 'true');

            let currentText = '';
            const currentValue = this.selectedValues;

            const activeItems = $(this.$popup).find('.swiper-slide-active');

            isA11ySwiperBtnChangeAria(); //스와이프 버튼 aria-hidden

            setTimeout(() => {
                activeItems?.each((idx, list) => {

                    $(list).parent().parent().find('.prev__btn').attr('aria-label', `${list?.innerText}, 이전 (감소 버튼)`);
                    $(list).parent().parent().find('.next__btn').attr('aria-label', `${list?.innerText}, 다음 (증가 버튼)`);
                });
            });

            activeItems?.each((idx,list) => {
                currentText += list.innerText;
                currentText += ' ';
            });

            if(type === 'change'){
                //캘린더 + dateSpinner 일때 title선택 텍스트 변경
                const depth = $($el).index();
                const isMixCalendarDateSpinner = Popup.arrPopup?.[0]?.attr('data-type') === 'calendar';
                    
                if(isMixCalendarDateSpinner){
                    if (this.$popup.find('.txt-guide-popup').length > 0 ) {
                        this.$popup.find('.txt-guide-popup')
                        ?.attr({'role':'button', 'title':'선택'})?.text(currentText);
                    } else {
                        this.$popup.find('.title-field-popup')
                        ?.attr({'role':'button', 'title':'선택'})?.text(currentText);
                    }
                    
                }
            }
        } catch (error) {
            throw new Error(`func isA11yAddInputArea ${error}`);
        }
    }

    isA11ySpinnerLive(type){
        try {
            if(type === 'create'){
                const liveDiv = document.createElement('div');
                liveDiv.setAttribute('aria-live','polite');
                liveDiv.setAttribute('aria-atomic','true');
                liveDiv.setAttribute('aria-relevant','additions text');
                liveDiv?.setAttribute('style', 'position:absolute;top:-99999px;left:-99999px;opacity:0;');
                liveDiv.classList.add('spinner-live');
                document.querySelector('body').append(liveDiv);
            }else if(type === 'remove'){
                const liveDiv = document.querySelector('.spinner-live');
                liveDiv.innerHTML = '';
            }
        } catch (error) {
            throw new Error(`func isA11ySpinnerLive ${error}`);
        }
    }
    initSwipeBtns(index){
        /**
         * 모바일에서 aria-disabled로 인해 이벤트 동작 안하는 현상 방지
         * @param index 현재 이전/다음버튼 영역 제외 버튼영역 값 재설정
         */
        this.swiperInstances.forEach((swipe) => {
            
            swipe.init();
            const item = $(swipe?.$wrapperEl);
    
            const isActive = $(item).find('.swiper-slide.swiper-slide-active').index();
            const slidesEle = $(item).find('.swiper-slide');
            const ulWrap = $(item)[0];
            const maxLength = $(item).find('.swiper-slide')?.length;
    
            //버튼 절대 좌표값 계산
            //const getPageOffset = window.pageYOffset;
            const swipeDivBox = ulWrap?.parentElement;
            const ulGetBoundRect = swipeDivBox?.getBoundingClientRect();
            const { top, width, bottom } = ulGetBoundRect;
            const buttonHeight = 40;
    
            const topOffset = top - buttonHeight;
            const bottomOffset = bottom;
    
            const selectText = slidesEle.eq(isActive).text();
    
            const prevBtn = document.createElement('button');
            prevBtn.classList.add('control-btn');
            prevBtn.classList.add('prev__btn');
    
            const nextBtn = document.createElement('button');
            nextBtn.classList.add('control-btn');
            nextBtn.classList.add('next__btn');
    
            prevBtn.setAttribute('role','button');
            prevBtn.setAttribute('style', `${!width && 'visibility:visible'};position:fixed;top:${topOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:-5;`);                                    
            
            prevBtn.setAttribute('aria-label', `${selectText}, 이전 (감소 버튼)`);
    
            $(ulWrap).attr('role','presentation');
            $(ulWrap).attr('aria-hidden','true');
            
            const $SwiperTarget = $(swipe.$el).find('.swiper-wrapper');

            // TODO - aria-disabled
            if(isActive === 0){
                $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'true');
            }else{
                $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');
            }
            
            $(swipeDivBox).find('.prev__btn')?.off('click.spinnerSwiper')?.on('click.spinnerSwiper', (e) => {
    
                const activeIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

                const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex - 1);

                setTimeout(() => {
                    const currentIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index()

                    // TODO - aria-disabled
                    if(currentIndex - 1 === 0){
                        $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'true');
                    }else{
                        $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');
                    }
                    $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'false');

                    if(activeIndex - 1 === 0) return;
                });

                isDateSpinnerNextTextForceReading(e.currentTarget, slidesEles?.text());
    
                if(activeIndex -1 >= 0){
                    swipe.slideTo(activeIndex - 1);
                }

                //spinner변경 텍스트
                setTimeout(() => {
                    let currentText = '';

                    const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');
    
                    activeItems?.each((idx,list) => {
                        currentText += list.innerText;
                        currentText += ' ';
                    });
    
                    console.log('isA11ySwiperSpinnerUpdate currentText', currentText);
    
                    setTimeout(() => {
                        const selectDiv = document.querySelector('.spinner-live');
    
                        const createText = document.createElement('div');
                        createText.innerText = `${currentText} 선택`;
                        
                        $(selectDiv)?.children().remove();
    
                        ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);
    
                        setTimeout(() => {
                            createText.remove();
                        },2000);
                    },1000);
                },500);
            });
    
    
            nextBtn.setAttribute('role','button');
            nextBtn.setAttribute('style', `${!width && 'visibility:visible'};position:fixed;top:${bottomOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:-5;`); 
    
            nextBtn.setAttribute('aria-label', `${selectText}, 다음 (증가 버튼)`);

            // TODO - aria-disabled
            if(isActive === maxLength -1){
                $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'true');
            }else{
                $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'false');
            }
    
            $(swipeDivBox).find('.next__btn')?.off('click.spinnerSwiper')?.on('click.spinnerSwiper', (e) => {
                const maxLength = $(e.currentTarget).parent().find('.swiper-slide')?.length;

                const activeIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

                const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex + 1);

                setTimeout(() => {
                    const currentIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

                    // TODO - aria-disabled
                    if(currentIndex === maxLength -1){
                        $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'true');
                    }else{
                        $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'false');
                    }
                    $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');

                    if(currentIndex === maxLength -1) return;
                });

                isDateSpinnerNextTextForceReading(e.currentTarget, slidesEles?.text());
    
    
                if(activeIndex + 1 < maxLength){
                    swipe.slideTo(activeIndex + 1);
                }

                //spinner변경 텍스트
                setTimeout(() => {
                    let currentText = '';

                    const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');
    
                    activeItems?.each((idx,list) => {
                        currentText += list.innerText;
                        currentText += ' ';
                    });
    
                    //console.log('isA11ySwiperSpinnerUpdate currentText', currentText);
    
                    setTimeout(() => {
                        const selectDiv = document.querySelector('.spinner-live');
    
                        const createText = document.createElement('div');
                        createText.innerText = `${currentText} 선택`;
                        
                        $(selectDiv)?.children().remove();
    
                        ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);
    
                        setTimeout(() => {
                            createText.remove();
                        },2000);
                    },1000);
                },500);
            });
    
            if($('#FPMDPT21000A300W')?.length){
                slidesEle.each((item, idx) => {
                    if($(item).text() === '직접입력'){
                        $(item).remove();
                    }
                });
            }

            isA11ySwiperBtnChangeAria(); //스와이프 버튼 aria-hidden
    
    
            swipe.on('slideChangeTransitionEnd', (sw) => {
                const { activeIndex, slides, $wrapperEl } = sw;
    
                if($(slides[activeIndex]).text() === '매월'){
                    $('#monthlyCyclSwiper').show();
                    $('#weeklyCyclSwiper').hide();
                }
    
                if($(slides[activeIndex]).text() === '매주'){
                    $('#monthlyCyclSwiper').hide();
                    $('#weeklyCyclSwiper').show();
                    
                }
    
                const curText = slides[activeIndex]?.innerText;
    
                $(swipeDivBox).find('.prev__btn').attr('aria-label', `${curText}, 이전 (감소 버튼)`);
                $(swipeDivBox).find('.next__btn').attr('aria-label', `${curText}, 다음 (증가 버튼)`);
    
                
                let currentText = '';
                const activeItems = $($wrapperEl).parent().parent().find('.swiper-slide-active');

                isA11ySwiperBtnChangeAria(); //스와이프 버튼 aria-hidden

                setTimeout(() => {
                    activeItems?.each((idx, list) => {
                        $(list).parent().parent().find('.prev__btn').attr('aria-label', `${list?.innerText}, 이전 (감소 버튼)`);
                        $(list).parent().parent().find('.next__btn').attr('aria-label', `${list?.innerText}, 다음 (증가 버튼)`);
                    });
                });
    
                activeItems?.each((idx,list) => {
                    currentText += list.innerText;
                });

                $(swipeDivBox).find('.prev__btn')?.off('click.spinnerSwiper')?.on('click.spinnerSwiper', (e) => {
    
                    const activeIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();
    
                    const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex - 1);

                    isDateSpinnerNextTextForceReading(e.currentTarget, slidesEles?.text());
        
                    if(activeIndex -1 >= 0){
                        swipe.slideTo(activeIndex - 1);
                    }

                    //spinner변경 텍스트
                    setTimeout(() => {
                        let currentText = '';

                        const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');

                        activeItems?.each((idx,list) => {
                            currentText += list.innerText;
                            currentText += ' ';
                        });

                        console.log('isA11ySwiperSpinnerUpdate currentText', currentText);

                        setTimeout(() => {
                            const selectDiv = document.querySelector('.spinner-live');

                            const createText = document.createElement('div');
                            createText.innerText = `${currentText} 선택`;
                            
                            $(selectDiv)?.children().remove();

                            ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);

                            setTimeout(() => {
                                createText.remove();
                            },2000);
                        },1000);
                    },500);
                });


                $(swipeDivBox).find('.next__btn')?.off('click.spinnerSwiper')?.on('click.spinnerSwiper', (e) => {
                
                    const activeIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

                    const maxLength = $(e.currentTarget).parent().find('.swiper-slide')?.length;

                    const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex + 1);

                    isDateSpinnerNextTextForceReading(e.currentTarget, slidesEles?.text());
        
                    if(activeIndex + 1 < maxLength){
                        swipe.slideTo(activeIndex + 1);
                    }
                    
                    //spinner변경 텍스트
                    setTimeout(() => {
                        let currentText = '';

                        const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');

                        activeItems?.each((idx,list) => {
                            currentText += list.innerText;
                            currentText += ' ';
                        });

                        console.log('isA11ySwiperSpinnerUpdate currentText', currentText);

                        setTimeout(() => {
                            const selectDiv = document.querySelector('.spinner-live');

                            const createText = document.createElement('div');
                            createText.innerText = `${currentText} 선택`;
                            
                            $(selectDiv)?.children().remove();

                            ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);

                            setTimeout(() => {
                                createText.remove();
                            },2000);
                        },1000);
                    },500);
                });
            });
    
            setTimeout(() => {
                $(swipeDivBox).find('.prev__btn').each((idx, item) => {
                    if(idx > 0){
                        $(item).remove();
                    }
                });
    
                $(swipeDivBox).find('.next__btn').each((idx, item) => {
                    if(idx > 0){
                        $(item).remove();
                    }
                });
            },500);
        });
    }

    closeReservationBtnChange($el){
        // 스피너 팝업 닫힐때 접근성 대응 코드
        const that = this;
        const preventBtnEles = $el.querySelectorAll('[data-role="valReset"]');

        if(preventBtnEles){
            preventBtnEles?.length && preventBtnEles?.forEach((item) => {
                const newBtnNode = document.createElement('a');
                newBtnNode.classList.add('newBtn_reset');
                newBtnNode.href = '#none';
                newBtnNode.setAttribute('data-role','valReset');
                newBtnNode.setAttribute('aria-hidden','true');
                newBtnNode.setAttribute('role','button');
                newBtnNode.setAttribute('title','입력내용삭제');

                const newIco = document.createElement('i');
                newIco.classList.add('ico-x');
                newIco.setAttribute('aria-hidden','true');

                newBtnNode.append(newIco);

                const inputWrap = $(that.$el).closest('.ui-input');
                const labelEle = $(that.$el).find('.label-field');
                
                $(newBtnNode).off(`click${this.eventId}`).on(`click${this.eventId}`, function(e){
                    
                    if(e.currentTarget){
                        setTimeout(() => {
                            inputWrap.removeClass('done');
                            inputWrap.find('.ui-text-del').val('');

                            $(that.$el).removeAttr('aria-label');

                            if($(that.$el).data('a11yTitle')){
                                $(that.$el).attr('title', `${$(that.$el).data('a11yTitle')}`);
                            }else{
                                $(that.$el).attr('title', `${labelEle.text()} 선택`);
                            }

                            e.currentTarget.setAttribute('aria-hidden','true');
                            if(e.currentTarget.nodeName !== 'HTML'){
                                e.currentTarget.style.display = 'none';
                            }
                        }, 500);
                    }
                });

                const config = {
                    subtree: false,
                    attributes: true,
                    attributeOldValue: true,
                    attributeFilter: ['aria-label'],
                };

                const observer = new MutationObserver(async (mutation) => {
                    const { target } = mutation[0];
                    const labelEle = $(that.$el).find('.label-field');

                    if(target.ariaLabel){
                        if(target.ariaLabel === `${labelEle.text()}`){
                            newBtnNode.setAttribute('aria-hidden', 'true');
                            newBtnNode.style.display = 'none';
                        }else{
                            newBtnNode.setAttribute('aria-hidden', 'false');
                            newBtnNode.removeAttribute('tabindex');
                            newBtnNode.style.display = 'block';
                        }
                    }else{
                        newBtnNode.setAttribute('aria-hidden', 'true');
                        newBtnNode.style.display = 'none';
                    }

                    $(that.$el).focus();
                });

                observer.observe($el, config);

                item.parentElement.after(newBtnNode);
            });
        }
    }

    async isA11ySelectTypeAcess(){
        //팝업 셀렉트 형태 혼합 popup시 실행 안되게 분기
        const delay = new Promise((resolve) => setTimeout(resolve, 500));

        await delay;

        const selectDiv = this.$el[0];
        const selectInputWrap =  selectDiv;
        const selectInput = selectDiv.querySelector('input');
        const selectLabel = selectDiv.querySelector('label') || selectDiv.querySelector('.txt-name') ;
        
        const selectBtn = selectDiv.querySelector('.btn-selectbox');

        const isDateSpinType = selectInputWrap?.dataset.type === 'dateSpinner';
        const valueText = !!selectInput?.value.length ? selectInput?.value : selectLabel?.innerHTML;

        selectDiv?.setAttribute('aria-label', valueText);

        if(selectBtn){
            selectDiv?.setAttribute('title', `${selectBtn?.attributes?.title?.value}`);
        }

        const newArrPopup = [...new Set(Popup.arrPopup)];

        const calendarTit = newArrPopup[newArrPopup?.length -1] && newArrPopup[newArrPopup?.length -1]?.find('.jui-datepicker-title');

        const delay1 = new Promise((resolve) => setTimeout(resolve, 800));

        await delay1;
        
        Popup.a11yDetctClosePopup();

        if(calendarTit?.length){
            calendarTit.focus();

            return;
        }
        
        if(this.defaults.item === 'cycle-date' && selectBtn){
            selectBtn?.focus();

            return;
        }
        
        if(isDateSpinType){
            selectInputWrap?.focus();

            return;
        }
        
        if(selectInput){
            selectInput?.focus();

            return;
        }
        
        if(selectDiv){
            selectDiv?.focus();

            return;
        }

        if(!Popup.arrPrePopup.length){
            const activeItem = document.querySelector('.activeSlide');
            isA11ySlideFocusMove(activeItem, 100);
        }
    }

    isA11yCheckDisabled(){
        const selectDiv = document.querySelectorAll('.disabled');

        if(selectDiv?.length){
            selectDiv?.forEach((item) =>  {
                item.setAttribute('aria-disabled', 'true');
            });
        }
    }

    isA11yCloseAfterCalendar(){
        // 데이트 스피너 + calendar 혼합형태 대응 코드
        if(Popup.arrPrePopup[0] && Popup.arrPrePopup[0]?.find('button')?.length){
            Popup.arrPrePopup[0]?.find('button')?.attr({'aria-hidden':'false'});
        }
    }
    /*! e: FETASK-a11y page v.1.0.0 */
}

export default DateSpinner;